import _ from "lodash";
import Mustache from "mustache";
import React, { Component } from "react";
import { connect } from "react-redux";
import { RoleFields } from "../../../../modules/stakeholder/graphql/typePolicies";
import { NoticesFragment, AuthorizedSignatoryFragment } from "../../../../modules/startup/Stakeholder/graphql/fragments";
import { goToPage, goToPrevPage } from '../../../../store/actions/page';
import { Loading } from "../../../components";
import {
	agreementGetSignatures,
	generateAgreement,
	getAgreementTypes,
	previewAgreement,
	requestSignatures
} from "../../../graphql/mutations/addAgreement";
import { getGroupCompaniesWrong } from "../../../graphql/mutations/addStakeholder";
import { ServerConnect } from "../../../utils";
import event from "../../../utils/event";
import { Constants } from "../../../utils";
import { stripTypenames } from "../../../utils/graphql-util";
import helper from "../../../utils/helper";
import notification from "../../../utils/notification";
import classes from "../SteperForm.module.scss";
import Wizard from "../wizard";
import Step2 from "./Common/Step2";
import Step3 from "./Common/Step3";
import Step4 from "./Common/Step4";
import Step5 from "./Common/Step5/Step5";
import StepToUploadEditedDoc from './Common/StepToUploadEditedDoc';
import FormsSelector from "./FormsGenerate/FormsSelector";
import { SaveByForm } from './FormsGenerate/helper'
import {
	validationsAdvisorAgreement,
	validationsCLNAgreement,
	validationsConsultantAgreement,
	validationsDefault,
	validationsEmploymentAgreement,
	validationsFoundersAgreement,
	validationsFoundersAgreement2,
	validationsFounderServicesAgreement,
	validationsFounderTerms,
	validationsGrantAgreement,
	validationSharesIncentivePlan,
	validationsIPAssignment,
	validationsKISSAgreement,
	validationsNDAMutual,
	validationsRestrictiveCovenantAgreement,
	validationsSAFEAgreement,
	validationsUploadToEdit,
	validationsWebsiteAcceptableUsePolicy,
	validationsWebsiteCookieNotice,
	validationsFoundersAgreement3,
	validationsWebsitePrivacyPolicy,
	validationsWebsiteTermsOfUse,
	validationsBRCAgreement,
	validationsEmploymentAgreementUK,
	validationsBoardResolutionConsentSAFE,
	validationsUsaNDA,
	validationsUploadToEditFile,
	validationsEmployeeInformationInventionsAgreement,
	validationsConsultantInformationInventionsAgreement,
	validationsAdvisoryBoardOfLetter,
	validationsUsaCalOfferLetterSalaryEmployee,
	validationsConsultingAgreement,
	validationsEquityIncentivePlan,
	validationsBoardApprovingOptionsGrant,
	validationsOptionGrantNotice

} from "./validations";
import { useParams } from "react-router";
import MicroFrontend from "src/mf";


class GenerateDocumentFormOld extends Component {

	groupCompanies = [];
	groupCompaniesList = [];
	authorizedSignatories = [];

	constructor(props) {
		super(props);
		this.state = {
			saveDisabled: false,
			counter: 0,
			showLoading: true,
			stakeholders: [],
			stakeholderList: [],
			groupCompanies: [],
			groupCompaniesList: [],
			documentsTypes: [],
			documentTypesList: [],
			authorizedSignatories: [],
			typeSelected: this.props.params.docType,
			extraValues: null,
			loadingStakeholders: true,
			loadingGroupCompanies: true,
			firstLoading: true,
			typeToEdit: null,
			extraButton: null,
			plusToStep: this.props.formType === "uploadToEdit" ? 1 : 0,
			documentList: [],
			nextButton:
				this.props.formType === "uploadToEdit"
				? false
				: {
				button: (
					<button style={{ 'width': '190px', 'height': '40px' }} data-cy="submit"
						className={`genericBlue`}>Generate Document</button>
				),
				onClick: this.generateAgreement
			},
			backButton: {
				button: undefined
			},
			showButtons: this.props.formType === "uploadToEdit" ? false : true,
			generatedAgreement: undefined,
			forceNextStep: {
				step: 0,
				values: props.data
			},
			validationSchema: this.props.formType === "uploadToEdit" ? validationsDefault.concat(validationsUploadToEditFile) : validationsDefault
		}
	}

	handleClose = () => {
		this.props.goToPage(Constants.PAGES.chooseDocumentType);
	};

	getPartiesType = (documentType) => {
		switch (documentType) {
			case "IP_ASSIGNMENT":
				return {
					partyStakeholder: {
						party: 'assignor',
						title: 'Assignor'
					},
					partyGroupCompany: {
						party: 'assignee',
						title: 'Assignee'
					}
				}
			case "SAFE":
				return {
					partyStakeholder: {
						party: 'investor',
						title: 'Investor'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "CONVERTIBLE_NOTE":
				return {
					partyStakeholder: {
						party: 'investor',
						title: 'Investor'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "ADVISOR_AGREEMENT":
				return {
					partyStakeholder: {
						party: 'advisor',
						title: 'Advisor'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "CONSULTANT_AGREEMENT":
				return {
					partyStakeholder: {
						party: 'consultant',
						title: 'Consultant'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "EMPLOYMENT_AGREEMENT_ADGM":
			case "EMPLOYMENT_AGREEMENT_DIFC":
			case "EMPLOYMENT_AGREEMENT_UK":
				return {
					partyStakeholder: {
						party: 'employee',
						title: 'Employee'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "BOARD_RESOLUTION":
			case "SHARE_INCENTIVE_PLAN_FAQ":
			case "SHARE_INCENTIVE_PLAN":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "FOUNDER_SERVICES_AGREEMENT":
				return {
					partyStakeholder: {
						party: 'founder',
						title: 'Founder'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				}
			case "GRANT_AGREEMENT":
				return {
					partyStakeholder: {
						party: 'participant',
						title: 'Participant'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "USA_OPTION_GRANT_NOTICE":
				return {
					partyStakeholder: {
						party: 'participant',
						title: 'Participant'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "USA_BOARD_APPROVING_OPTION_GRANT":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "RESTRICTIVE_COVENANT_AGREEMENT":
				return {
					partyStakeholder: {
						party: 'teamMember',
						title: 'Team Member'//Ver si debo poner consultant
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "EXERCISE_NOTICE":
				return {
					partyStakeholder: {
						party: 'participant',
						title: 'Participant'
					}
				};
			case "NDA_MUTUAL":
				return {
					partyStakeholder: {
						party: 'stakeholder',
						title: 'Party One'
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Party Two'
					}
				};
			case "FOUNDERS_AGREEMENT":
				return {
					partyStakeholder: {
						party: 'founders',
						title: 'Founders',
						isIndividual: false
					},
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				}
			case "BOARD_RESOLUTION_CONVERTIBLE_LOAN_NOTE":
			case "BOARD_RESOLUTION_CONVERTIBLE_SAFE":
			case "BOARD_RESOLUTION_CONVERTIBLE_KISS":
			case "BOARD_RESOLUTION_CONVERTIBLE_FIXED_EQUITY":
			case "BOARD_RESOLUTION_CONVERTIBLE_OTHER":
			case "BOARD_RESOLUTION_CONVERTIBLE":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				};
			case "USA_BOARD_CONSENT_SAFE_CONVERTIBLE_LOAN_NOTE":
			case "USA_BOARD_CONSENT_SAFE_SAFE":
			case "USA_BOARD_CONSENT_SAFE_KISS":
			case "USA_BOARD_CONSENT_SAFE_FIXED_EQUITY":
			case "USA_BOARD_CONSENT_SAFE_OTHER":
			case "USA_BOARD_CONSENT_SAFE":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					}
				}
			case "USA_CONSULTANT_INFORMATION_AND_INVENTIONS_AGREEMENT":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					},
					partyStakeholder: {
						party: 'consultant',
						title: 'Consultant'
					}
				}
			case "USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					},
					partyStakeholder: {
						party: 'employee',
						title: 'Employee'
					}
				}
			case "USA_NDA":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					},
					partyStakeholder: {
						party: 'stakeholder',
						title: 'Other Party'
					},
				};

			//CP-5321
			case "USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					},
					partyStakeholder: {
						party: 'stakeholder',
						title: 'Employee'
					},
				};
			case "USA_CONSULTING_AGREEMENT":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					},
					partyStakeholder: {
						party: 'consultant',
						title: 'Consultant'
					},
				};
			case "USA_STRATEGIC_ADVISORY_BOARD_LETTER":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					},
					partyStakeholder: {
						party: 'advisor',
						title: 'Advisor'
					},
				};
			case "USA_EQUITY_INCENTIVE_PLAN":
			case "USA_STAKEHOLDERS_DIRECTORS_EQUITY_INCENTIVE_PLAN":
				return {
					partyGroupCompany: {
						party: 'company',
						title: 'Company'
					},
					partyStakeholder: {
						party: 'stakeholders',
						isIndividual: false,
						title: 'Stockholders'
					},
				};
			default:
				break;
		}
	};

	getStep5ByDocumentType = (documentType) => { // values => Formik
		const { values } = this.state.forceNextStep;
		const partiesType = this.getPartiesType(documentType);
		return (<>
			<Step5
				partiesType={partiesType}
				parties={[]}
				params={values}
				groupCompaniesList={this.state.groupCompaniesList}
				stakeholderList={this.state.stakeholderList}
				documentTypesList={this.state.documentTypesList}
			/>
		</>)

	};
	formatValueByDocumentV2(docType, values,name) {
		let newValues = _.cloneDeep(values);
		switch (docType.code) {
			case "SAFE":
				const investorRights = [];
				newValues.agreementName = name;
				if (!_.isArray(newValues?.terms?.investorRights)) {
					if (newValues?.terms?.investorRights?.hasMFNRight) {
						investorRights.push("MFNRight")
					}
					if (newValues?.terms?.investorRights?.hasParticipationRight) {
						investorRights.push("participationRight")
					}
					if (newValues?.terms?.investorRights?.hasInformationRights) {
						investorRights.push("informationRights")
					}
					newValues.terms.investorRights = investorRights;
				}
				break;
			default:
				break;

		}
		return newValues
	}
	componentWillMount() {

		ServerConnect.graphQlQuery(getAgreementTypes).then(result => {
			const documentsTypes = result.getDocumentTypes.filter(agt =>
				agt.code === "IP_ASSIGNMENT" ||
				agt.code === "SAFE" ||
				agt.code === "CONVERTIBLE_NOTE" ||
				agt.code === "ADVISOR_AGREEMENT" ||
				agt.code === "CONSULTANT_AGREEMENT" ||
				agt.code === "EMPLOYMENT_AGREEMENT_ADGM" ||
				agt.code === "EMPLOYMENT_AGREEMENT_DIFC" ||
				agt.code === "EMPLOYMENT_AGREEMENT_UK" ||
				agt.code === "NDA_MUTUAL" ||
				agt.code === "FOUNDER_SERVICES_AGREEMENT" ||
				agt.code === "GRANT_AGREEMENT" ||
				agt.code === "BOARD_RESOLUTION" ||
				agt.code === "SHARE_INCENTIVE_PLAN_FAQ" ||
				agt.code === "SHARE_INCENTIVE_PLAN" ||
				agt.code === "WEBSITE_TERMS_OF_USE" ||
				agt.code === "WEBSITE_PRIVACY_POLICY" ||
				agt.code === "WEBSITE_ACCEPTABLE_USE_POLICY" ||
				agt.code === "WEBSITE_COOKIE_NOTICE" ||
				agt.code === "RESTRICTIVE_COVENANT_AGREEMENT" ||
				agt.code === "FOUNDERS_TERM_SHEET" ||
				agt.code === "FOUNDERS_AGREEMENT" ||
				agt.code === "BOARD_RESOLUTION_CONVERTIBLE" ||
				agt.code === "BOARD_RESOLUTION_CONVERTIBLE_LOAN_NOTE" ||
				agt.code === "BOARD_RESOLUTION_CONVERTIBLE_SAFE" ||
				agt.code === "BOARD_RESOLUTION_CONVERTIBLE_KISS" ||
				agt.code === "BOARD_RESOLUTION_CONVERTIBLE_FIXED_EQUITY" ||
				agt.code === "BOARD_RESOLUTION_CONVERTIBLE_OTHER" ||
				agt.code === "USA_BOARD_CONSENT_SAFE" ||
				agt.code === "USA_BOARD_CONSENT_SAFE_CONVERTIBLE_LOAN_NOTE" ||
				agt.code === "USA_BOARD_CONSENT_SAFE_SAFE" ||
				agt.code === "USA_BOARD_CONSENT_SAFE_KISS" ||
				agt.code === "USA_BOARD_CONSENT_SAFE_FIXED_EQUITY" ||
				agt.code === "USA_BOARD_CONSENT_SAFE_OTHER" ||
				agt.code === "USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT" ||
				agt.code === "USA_CONSULTANT_INFORMATION_AND_INVENTIONS_AGREEMENT" ||
				agt.code === "USA_NDA" ||
				agt.code === "USA_STRATEGIC_ADVISORY_BOARD_LETTER" ||
				//CP-5321
				agt.code === "USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE" ||
				agt.code === "USA_CONSULTING_AGREEMENT" ||
				agt.code === "USA_EQUITY_INCENTIVE_PLAN" ||
				agt.code === "USA_STAKEHOLDERS_DIRECTORS_EQUITY_INCENTIVE_PLAN" ||
				agt.code === "USA_BOARD_APPROVING_OPTION_GRANT" ||
				agt.code === "USA_OPTION_GRANT_NOTICE"
			)
			this.setState({
				documentsTypes,
				documentTypesList: documentsTypes
					.map(agrType => ({
						id: agrType.code,
						label: agrType.label
					}))
			});
		});

		// if edit document
		if (this.props.params.id) {
			let variables = {
				startupId: this.props.session.startup.id,
				agreementId: this.props.params.id
			};

			const query = Mustache.render(agreementGetSignatures, variables);
			ServerConnect.graphQlQuery(query).then(result => {
				let {
					type,
					name,
					stakeholders,
					groupCompanies,
					terms,
					expirationDate,
					params,
					parentDocument,
					relatedDocuments,
					isReplaced
				} = result.getDocument;


				let values = null;
				let newState = {};
				if (_.isEmpty(params)) {

					let { signedBy = {}, groupCompany = {} } = _.isEmpty(groupCompanies) ? {} : _.head(groupCompanies);
					let st = _.head(stakeholders);

					values = {
						assignor: st,
						assignee: {
							...groupCompany,
							authorizedSignatories: signedBy
						},
						documentType: type.code,
						agreementName: name,
						expirationDate,
						terms: terms || []

					};
					newState = {
						showLoading: false,
						forceNextStep: {
							step: 0,
							values: values || params,
							typeToEdit: type.code
						},
						documentReplaced: isReplaced
						// relatedDocuments: relatedDocuments
					};
				} else {
					newState = {
						showLoading: false,
						forceNextStep: {
							step: 0,
							values: values || params
						},
						documentReplaced: isReplaced,
						// relatedDocuments: relatedDocuments
					};
				}
				if (this.props.formType === "uploadToEdit" && !this.props.params.templateId) {

					if (this.state.forceNextStep.step === 0) {
						let newValues = this.formatValueByDocumentV2(type, newState.forceNextStep.values,name)
						newState = {
							...newState,
							forceNextStep: {
								step: 0,
								values: { ...newValues, file: null }
							},
							showButtons: true,
							footer: undefined,
							showSteps: false,
							nextButton: {
								button: (
									<svg width="191" height="40" viewBox="0 0 191 40" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M0 4C0 1.79086 1.79086 0 4 0H187C189.209 0 191 1.79086 191 4V36C191 38.2091 189.209 40 187 40H4C1.79086 40 0 38.2091 0 36V4Z"
											fill="#2C74FF" />
										<path
											d="M23.7594 24H22.3424L21.1854 20.919C21.0641 20.5897 20.8864 20.3643 20.6524 20.243C20.4184 20.113 20.0978 20.048 19.6904 20.048H17.6624V24H16.3364V14.744H20.1454C21.1594 14.744 21.9351 14.9693 22.4724 15.42C23.0184 15.8707 23.2914 16.5163 23.2914 17.357C23.2914 17.9637 23.1311 18.4793 22.8104 18.904C22.4898 19.3287 22.0348 19.6277 21.4454 19.801C21.9828 19.8963 22.3728 20.2777 22.6154 20.945L23.7594 24ZM19.9894 18.969C20.6654 18.969 21.1681 18.839 21.4974 18.579C21.8268 18.3103 21.9914 17.9117 21.9914 17.383C21.9914 16.8543 21.8268 16.4643 21.4974 16.213C21.1768 15.953 20.6741 15.823 19.9894 15.823H17.6624V18.969H19.9894ZM31.0039 20.75H26.3239C26.3672 22.284 27.0649 23.051 28.4169 23.051C29.1709 23.051 29.8599 22.804 30.4839 22.31L30.8869 23.246C30.5922 23.506 30.2152 23.714 29.7559 23.87C29.3052 24.0173 28.8502 24.091 28.3909 24.091C27.3422 24.091 26.5189 23.792 25.9209 23.194C25.3229 22.5873 25.0239 21.7597 25.0239 20.711C25.0239 20.0437 25.1539 19.45 25.4139 18.93C25.6826 18.41 26.0552 18.007 26.5319 17.721C27.0086 17.435 27.5502 17.292 28.1569 17.292C29.0409 17.292 29.7342 17.578 30.2369 18.15C30.7482 18.722 31.0039 19.515 31.0039 20.529V20.75ZM28.1829 18.267C27.6889 18.267 27.2859 18.4143 26.9739 18.709C26.6619 19.0037 26.4626 19.424 26.3759 19.97H29.8469C29.7949 19.4153 29.6259 18.995 29.3399 18.709C29.0539 18.4143 28.6682 18.267 28.1829 18.267ZM38.5057 17.461L35.6587 24H34.4757L31.6547 17.461H33.0457L35.0997 22.518L37.1927 17.461H38.5057ZM39.6514 17.448H40.9514V24H39.6514V17.448ZM41.0554 14.588V15.966H39.5344V14.588H41.0554ZM48.596 20.75H43.916C43.9594 22.284 44.657 23.051 46.009 23.051C46.763 23.051 47.452 22.804 48.076 22.31L48.479 23.246C48.1844 23.506 47.8074 23.714 47.348 23.87C46.8974 24.0173 46.4424 24.091 45.983 24.091C44.9344 24.091 44.111 23.792 43.513 23.194C42.915 22.5873 42.616 21.7597 42.616 20.711C42.616 20.0437 42.746 19.45 43.006 18.93C43.2747 18.41 43.6474 18.007 44.124 17.721C44.6007 17.435 45.1424 17.292 45.749 17.292C46.633 17.292 47.3264 17.578 47.829 18.15C48.3404 18.722 48.596 19.515 48.596 20.529V20.75ZM45.775 18.267C45.281 18.267 44.878 18.4143 44.566 18.709C44.254 19.0037 44.0547 19.424 43.968 19.97H47.439C47.387 19.4153 47.218 18.995 46.932 18.709C46.646 18.4143 46.2604 18.267 45.775 18.267ZM60.3099 17.448L57.8139 24H56.6179L54.8629 19.255L53.1209 24H51.9249L49.4289 17.448H50.7939L52.5749 22.453L54.3819 17.448H55.4219L57.2289 22.453L59.0229 17.448H60.3099ZM65.3744 14.744H68.6114C70.1107 14.744 71.272 15.147 72.0954 15.953C72.9187 16.759 73.3304 17.8943 73.3304 19.359C73.3304 20.8323 72.9187 21.9763 72.0954 22.791C71.272 23.597 70.1107 24 68.6114 24H65.3744V14.744ZM68.5334 22.882C70.8127 22.882 71.9524 21.7077 71.9524 19.359C71.9524 17.0277 70.8127 15.862 68.5334 15.862H66.7134V22.882H68.5334ZM77.9965 24.091C77.3551 24.091 76.7918 23.9523 76.3065 23.675C75.8211 23.3977 75.4441 23.0033 75.1755 22.492C74.9155 21.9807 74.7855 21.3827 74.7855 20.698C74.7855 20.0133 74.9155 19.4153 75.1755 18.904C75.4441 18.384 75.8211 17.9853 76.3065 17.708C76.7918 17.4307 77.3551 17.292 77.9965 17.292C78.6291 17.292 79.1881 17.4307 79.6735 17.708C80.1588 17.9853 80.5315 18.384 80.7915 18.904C81.0601 19.4153 81.1945 20.0133 81.1945 20.698C81.1945 21.3827 81.0601 21.9807 80.7915 22.492C80.5315 23.0033 80.1588 23.3977 79.6735 23.675C79.1881 23.9523 78.6291 24.091 77.9965 24.091ZM77.9835 23.051C78.5901 23.051 79.0538 22.8517 79.3745 22.453C79.6951 22.0543 79.8555 21.4693 79.8555 20.698C79.8555 19.944 79.6908 19.3633 79.3615 18.956C79.0408 18.5487 78.5858 18.345 77.9965 18.345C77.3985 18.345 76.9348 18.5487 76.6055 18.956C76.2761 19.3633 76.1115 19.944 76.1115 20.698C76.1115 21.4693 76.2718 22.0543 76.5925 22.453C76.9218 22.8517 77.3855 23.051 77.9835 23.051ZM85.7062 24.091C85.0475 24.091 84.4712 23.9523 83.9772 23.675C83.4918 23.3977 83.1192 23.0077 82.8592 22.505C82.5992 21.9937 82.4692 21.4 82.4692 20.724C82.4692 20.048 82.6035 19.45 82.8722 18.93C83.1495 18.41 83.5352 18.007 84.0292 17.721C84.5232 17.435 85.0995 17.292 85.7582 17.292C86.2175 17.292 86.6595 17.37 87.0842 17.526C87.5088 17.6733 87.8512 17.877 88.1112 18.137L87.7082 19.086C87.0928 18.6007 86.4732 18.358 85.8492 18.358C85.2165 18.358 84.7225 18.566 84.3672 18.982C84.0118 19.3893 83.8342 19.9657 83.8342 20.711C83.8342 21.4563 84.0118 22.0327 84.3672 22.44C84.7225 22.8387 85.2165 23.038 85.8492 23.038C86.4905 23.038 87.1102 22.7953 87.7082 22.31L88.1112 23.259C87.8338 23.519 87.4785 23.7227 87.0452 23.87C86.6205 24.0173 86.1742 24.091 85.7062 24.091ZM95.1705 17.448V24H93.8965V22.908C93.6885 23.2893 93.4025 23.584 93.0385 23.792C92.6745 23.9913 92.2628 24.091 91.8035 24.091C90.2261 24.091 89.4375 23.2157 89.4375 21.465V17.448H90.7375V21.452C90.7375 21.9893 90.8458 22.388 91.0625 22.648C91.2878 22.8993 91.6258 23.025 92.0765 23.025C92.6138 23.025 93.0428 22.8517 93.3635 22.505C93.6928 22.1583 93.8575 21.699 93.8575 21.127V17.448H95.1705ZM104.699 17.292C106.155 17.292 106.883 18.1673 106.883 19.918V24H105.57V19.983C105.57 19.4197 105.47 19.008 105.271 18.748C105.08 18.488 104.768 18.358 104.335 18.358C103.832 18.358 103.433 18.5313 103.139 18.878C102.853 19.2247 102.71 19.697 102.71 20.295V24H101.397V19.983C101.397 19.4197 101.297 19.008 101.098 18.748C100.907 18.488 100.595 18.358 100.162 18.358C99.659 18.358 99.2603 18.5313 98.9657 18.878C98.671 19.2247 98.5237 19.697 98.5237 20.295V24H97.2237V19.294C97.2237 18.6093 97.189 17.994 97.1197 17.448H98.3417L98.4587 18.54C98.6493 18.1413 98.9223 17.8337 99.2777 17.617C99.633 17.4003 100.049 17.292 100.526 17.292C101.54 17.292 102.203 17.7123 102.515 18.553C102.714 18.163 103.004 17.8553 103.386 17.63C103.776 17.4047 104.213 17.292 104.699 17.292ZM114.484 20.75H109.804C109.847 22.284 110.545 23.051 111.897 23.051C112.651 23.051 113.34 22.804 113.964 22.31L114.367 23.246C114.072 23.506 113.695 23.714 113.236 23.87C112.785 24.0173 112.33 24.091 111.871 24.091C110.822 24.091 109.999 23.792 109.401 23.194C108.803 22.5873 108.504 21.7597 108.504 20.711C108.504 20.0437 108.634 19.45 108.894 18.93C109.162 18.41 109.535 18.007 110.012 17.721C110.488 17.435 111.03 17.292 111.637 17.292C112.521 17.292 113.214 17.578 113.717 18.15C114.228 18.722 114.484 19.515 114.484 20.529V20.75ZM111.663 18.267C111.169 18.267 110.766 18.4143 110.454 18.709C110.142 19.0037 109.942 19.424 109.856 19.97H113.327C113.275 19.4153 113.106 18.995 112.82 18.709C112.534 18.4143 112.148 18.267 111.663 18.267ZM119.604 17.292C121.173 17.292 121.957 18.1673 121.957 19.918V24H120.644V19.996C120.644 19.424 120.532 19.008 120.306 18.748C120.09 18.488 119.739 18.358 119.253 18.358C118.699 18.358 118.252 18.5313 117.914 18.878C117.585 19.2247 117.42 19.6883 117.42 20.269V24H116.12V19.294C116.12 18.6093 116.086 17.994 116.016 17.448H117.238L117.355 18.579C117.563 18.163 117.862 17.8467 118.252 17.63C118.651 17.4047 119.102 17.292 119.604 17.292ZM125.659 18.462V21.751C125.659 22.2017 125.755 22.5223 125.945 22.713C126.145 22.895 126.418 22.986 126.764 22.986C126.99 22.986 127.219 22.9513 127.453 22.882V23.948C127.167 24.0433 126.842 24.091 126.478 24.091C125.802 24.091 125.278 23.9003 124.905 23.519C124.533 23.1377 124.346 22.583 124.346 21.855V18.462H123.072V17.448H124.346V15.81L125.659 15.355V17.448H127.466V18.462H125.659ZM132.522 14.744H135.759C137.258 14.744 138.42 15.147 139.243 15.953C140.066 16.759 140.478 17.8943 140.478 19.359C140.478 20.8323 140.066 21.9763 139.243 22.791C138.42 23.597 137.258 24 135.759 24H132.522V14.744ZM135.681 22.882C137.96 22.882 139.1 21.7077 139.1 19.359C139.1 17.0277 137.96 15.862 135.681 15.862H133.861V22.882H135.681ZM147.913 20.75H143.233C143.276 22.284 143.974 23.051 145.326 23.051C146.08 23.051 146.769 22.804 147.393 22.31L147.796 23.246C147.501 23.506 147.124 23.714 146.665 23.87C146.214 24.0173 145.759 24.091 145.3 24.091C144.251 24.091 143.428 23.792 142.83 23.194C142.232 22.5873 141.933 21.7597 141.933 20.711C141.933 20.0437 142.063 19.45 142.323 18.93C142.592 18.41 142.964 18.007 143.441 17.721C143.918 17.435 144.459 17.292 145.066 17.292C145.95 17.292 146.643 17.578 147.146 18.15C147.657 18.722 147.913 19.515 147.913 20.529V20.75ZM145.092 18.267C144.598 18.267 144.195 18.4143 143.883 18.709C143.571 19.0037 143.372 19.424 143.285 19.97H146.756C146.704 19.4153 146.535 18.995 146.249 18.709C145.963 18.4143 145.577 18.267 145.092 18.267ZM151.189 18.462V21.751C151.189 22.2017 151.285 22.5223 151.475 22.713C151.675 22.895 151.948 22.986 152.294 22.986C152.52 22.986 152.749 22.9513 152.983 22.882V23.948C152.697 24.0433 152.372 24.091 152.008 24.091C151.332 24.091 150.808 23.9003 150.435 23.519C150.063 23.1377 149.876 22.583 149.876 21.855V18.462H148.602V17.448H149.876V15.81L151.189 15.355V17.448H152.996V18.462H151.189ZM160.332 17.448V24H159.032V22.882C158.841 23.272 158.555 23.571 158.174 23.779C157.801 23.987 157.364 24.091 156.861 24.091C156.28 24.091 155.769 23.9523 155.327 23.675C154.894 23.3977 154.556 23.0077 154.313 22.505C154.07 21.9937 153.949 21.4 153.949 20.724C153.949 20.048 154.07 19.45 154.313 18.93C154.564 18.41 154.911 18.007 155.353 17.721C155.795 17.435 156.298 17.292 156.861 17.292C157.364 17.292 157.801 17.4003 158.174 17.617C158.547 17.825 158.833 18.124 159.032 18.514V17.448H160.332ZM157.173 23.051C157.762 23.051 158.217 22.8473 158.538 22.44C158.867 22.024 159.032 21.4433 159.032 20.698C159.032 19.944 158.867 19.3633 158.538 18.956C158.217 18.5487 157.758 18.345 157.16 18.345C156.571 18.345 156.107 18.5573 155.769 18.982C155.44 19.398 155.275 19.9787 155.275 20.724C155.275 21.4607 155.44 22.0327 155.769 22.44C156.107 22.8473 156.575 23.051 157.173 23.051ZM162.391 17.448H163.691V24H162.391V17.448ZM163.795 14.588V15.966H162.274V14.588H163.795ZM165.745 14.432H167.045V24H165.745V14.432ZM171.388 24.091C170.244 24.091 169.343 23.8137 168.684 23.259L169.074 22.31C169.759 22.83 170.543 23.09 171.427 23.09C171.878 23.09 172.22 23.0163 172.454 22.869C172.688 22.713 172.805 22.4963 172.805 22.219C172.805 21.985 172.723 21.803 172.558 21.673C172.402 21.5343 172.133 21.4173 171.7"
											fill="white" />
									</svg>

								),
								onClick: this.uploadToEditFirstButton
							}
						};
					}
					newState = {
						...newState,
						showButtons: true,
						footer: undefined,
						showSteps: false,
						nextButton: {
							button: (
								<svg width="191" height="40" viewBox="0 0 191 40" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M0 4C0 1.79086 1.79086 0 4 0H187C189.209 0 191 1.79086 191 4V36C191 38.2091 189.209 40 187 40H4C1.79086 40 0 38.2091 0 36V4Z"
										fill="#2C74FF" />
									<path
										d="M23.7594 24H22.3424L21.1854 20.919C21.0641 20.5897 20.8864 20.3643 20.6524 20.243C20.4184 20.113 20.0978 20.048 19.6904 20.048H17.6624V24H16.3364V14.744H20.1454C21.1594 14.744 21.9351 14.9693 22.4724 15.42C23.0184 15.8707 23.2914 16.5163 23.2914 17.357C23.2914 17.9637 23.1311 18.4793 22.8104 18.904C22.4898 19.3287 22.0348 19.6277 21.4454 19.801C21.9828 19.8963 22.3728 20.2777 22.6154 20.945L23.7594 24ZM19.9894 18.969C20.6654 18.969 21.1681 18.839 21.4974 18.579C21.8268 18.3103 21.9914 17.9117 21.9914 17.383C21.9914 16.8543 21.8268 16.4643 21.4974 16.213C21.1768 15.953 20.6741 15.823 19.9894 15.823H17.6624V18.969H19.9894ZM31.0039 20.75H26.3239C26.3672 22.284 27.0649 23.051 28.4169 23.051C29.1709 23.051 29.8599 22.804 30.4839 22.31L30.8869 23.246C30.5922 23.506 30.2152 23.714 29.7559 23.87C29.3052 24.0173 28.8502 24.091 28.3909 24.091C27.3422 24.091 26.5189 23.792 25.9209 23.194C25.3229 22.5873 25.0239 21.7597 25.0239 20.711C25.0239 20.0437 25.1539 19.45 25.4139 18.93C25.6826 18.41 26.0552 18.007 26.5319 17.721C27.0086 17.435 27.5502 17.292 28.1569 17.292C29.0409 17.292 29.7342 17.578 30.2369 18.15C30.7482 18.722 31.0039 19.515 31.0039 20.529V20.75ZM28.1829 18.267C27.6889 18.267 27.2859 18.4143 26.9739 18.709C26.6619 19.0037 26.4626 19.424 26.3759 19.97H29.8469C29.7949 19.4153 29.6259 18.995 29.3399 18.709C29.0539 18.4143 28.6682 18.267 28.1829 18.267ZM38.5057 17.461L35.6587 24H34.4757L31.6547 17.461H33.0457L35.0997 22.518L37.1927 17.461H38.5057ZM39.6514 17.448H40.9514V24H39.6514V17.448ZM41.0554 14.588V15.966H39.5344V14.588H41.0554ZM48.596 20.75H43.916C43.9594 22.284 44.657 23.051 46.009 23.051C46.763 23.051 47.452 22.804 48.076 22.31L48.479 23.246C48.1844 23.506 47.8074 23.714 47.348 23.87C46.8974 24.0173 46.4424 24.091 45.983 24.091C44.9344 24.091 44.111 23.792 43.513 23.194C42.915 22.5873 42.616 21.7597 42.616 20.711C42.616 20.0437 42.746 19.45 43.006 18.93C43.2747 18.41 43.6474 18.007 44.124 17.721C44.6007 17.435 45.1424 17.292 45.749 17.292C46.633 17.292 47.3264 17.578 47.829 18.15C48.3404 18.722 48.596 19.515 48.596 20.529V20.75ZM45.775 18.267C45.281 18.267 44.878 18.4143 44.566 18.709C44.254 19.0037 44.0547 19.424 43.968 19.97H47.439C47.387 19.4153 47.218 18.995 46.932 18.709C46.646 18.4143 46.2604 18.267 45.775 18.267ZM60.3099 17.448L57.8139 24H56.6179L54.8629 19.255L53.1209 24H51.9249L49.4289 17.448H50.7939L52.5749 22.453L54.3819 17.448H55.4219L57.2289 22.453L59.0229 17.448H60.3099ZM65.3744 14.744H68.6114C70.1107 14.744 71.272 15.147 72.0954 15.953C72.9187 16.759 73.3304 17.8943 73.3304 19.359C73.3304 20.8323 72.9187 21.9763 72.0954 22.791C71.272 23.597 70.1107 24 68.6114 24H65.3744V14.744ZM68.5334 22.882C70.8127 22.882 71.9524 21.7077 71.9524 19.359C71.9524 17.0277 70.8127 15.862 68.5334 15.862H66.7134V22.882H68.5334ZM77.9965 24.091C77.3551 24.091 76.7918 23.9523 76.3065 23.675C75.8211 23.3977 75.4441 23.0033 75.1755 22.492C74.9155 21.9807 74.7855 21.3827 74.7855 20.698C74.7855 20.0133 74.9155 19.4153 75.1755 18.904C75.4441 18.384 75.8211 17.9853 76.3065 17.708C76.7918 17.4307 77.3551 17.292 77.9965 17.292C78.6291 17.292 79.1881 17.4307 79.6735 17.708C80.1588 17.9853 80.5315 18.384 80.7915 18.904C81.0601 19.4153 81.1945 20.0133 81.1945 20.698C81.1945 21.3827 81.0601 21.9807 80.7915 22.492C80.5315 23.0033 80.1588 23.3977 79.6735 23.675C79.1881 23.9523 78.6291 24.091 77.9965 24.091ZM77.9835 23.051C78.5901 23.051 79.0538 22.8517 79.3745 22.453C79.6951 22.0543 79.8555 21.4693 79.8555 20.698C79.8555 19.944 79.6908 19.3633 79.3615 18.956C79.0408 18.5487 78.5858 18.345 77.9965 18.345C77.3985 18.345 76.9348 18.5487 76.6055 18.956C76.2761 19.3633 76.1115 19.944 76.1115 20.698C76.1115 21.4693 76.2718 22.0543 76.5925 22.453C76.9218 22.8517 77.3855 23.051 77.9835 23.051ZM85.7062 24.091C85.0475 24.091 84.4712 23.9523 83.9772 23.675C83.4918 23.3977 83.1192 23.0077 82.8592 22.505C82.5992 21.9937 82.4692 21.4 82.4692 20.724C82.4692 20.048 82.6035 19.45 82.8722 18.93C83.1495 18.41 83.5352 18.007 84.0292 17.721C84.5232 17.435 85.0995 17.292 85.7582 17.292C86.2175 17.292 86.6595 17.37 87.0842 17.526C87.5088 17.6733 87.8512 17.877 88.1112 18.137L87.7082 19.086C87.0928 18.6007 86.4732 18.358 85.8492 18.358C85.2165 18.358 84.7225 18.566 84.3672 18.982C84.0118 19.3893 83.8342 19.9657 83.8342 20.711C83.8342 21.4563 84.0118 22.0327 84.3672 22.44C84.7225 22.8387 85.2165 23.038 85.8492 23.038C86.4905 23.038 87.1102 22.7953 87.7082 22.31L88.1112 23.259C87.8338 23.519 87.4785 23.7227 87.0452 23.87C86.6205 24.0173 86.1742 24.091 85.7062 24.091ZM95.1705 17.448V24H93.8965V22.908C93.6885 23.2893 93.4025 23.584 93.0385 23.792C92.6745 23.9913 92.2628 24.091 91.8035 24.091C90.2261 24.091 89.4375 23.2157 89.4375 21.465V17.448H90.7375V21.452C90.7375 21.9893 90.8458 22.388 91.0625 22.648C91.2878 22.8993 91.6258 23.025 92.0765 23.025C92.6138 23.025 93.0428 22.8517 93.3635 22.505C93.6928 22.1583 93.8575 21.699 93.8575 21.127V17.448H95.1705ZM104.699 17.292C106.155 17.292 106.883 18.1673 106.883 19.918V24H105.57V19.983C105.57 19.4197 105.47 19.008 105.271 18.748C105.08 18.488 104.768 18.358 104.335 18.358C103.832 18.358 103.433 18.5313 103.139 18.878C102.853 19.2247 102.71 19.697 102.71 20.295V24H101.397V19.983C101.397 19.4197 101.297 19.008 101.098 18.748C100.907 18.488 100.595 18.358 100.162 18.358C99.659 18.358 99.2603 18.5313 98.9657 18.878C98.671 19.2247 98.5237 19.697 98.5237 20.295V24H97.2237V19.294C97.2237 18.6093 97.189 17.994 97.1197 17.448H98.3417L98.4587 18.54C98.6493 18.1413 98.9223 17.8337 99.2777 17.617C99.633 17.4003 100.049 17.292 100.526 17.292C101.54 17.292 102.203 17.7123 102.515 18.553C102.714 18.163 103.004 17.8553 103.386 17.63C103.776 17.4047 104.213 17.292 104.699 17.292ZM114.484 20.75H109.804C109.847 22.284 110.545 23.051 111.897 23.051C112.651 23.051 113.34 22.804 113.964 22.31L114.367 23.246C114.072 23.506 113.695 23.714 113.236 23.87C112.785 24.0173 112.33 24.091 111.871 24.091C110.822 24.091 109.999 23.792 109.401 23.194C108.803 22.5873 108.504 21.7597 108.504 20.711C108.504 20.0437 108.634 19.45 108.894 18.93C109.162 18.41 109.535 18.007 110.012 17.721C110.488 17.435 111.03 17.292 111.637 17.292C112.521 17.292 113.214 17.578 113.717 18.15C114.228 18.722 114.484 19.515 114.484 20.529V20.75ZM111.663 18.267C111.169 18.267 110.766 18.4143 110.454 18.709C110.142 19.0037 109.942 19.424 109.856 19.97H113.327C113.275 19.4153 113.106 18.995 112.82 18.709C112.534 18.4143 112.148 18.267 111.663 18.267ZM119.604 17.292C121.173 17.292 121.957 18.1673 121.957 19.918V24H120.644V19.996C120.644 19.424 120.532 19.008 120.306 18.748C120.09 18.488 119.739 18.358 119.253 18.358C118.699 18.358 118.252 18.5313 117.914 18.878C117.585 19.2247 117.42 19.6883 117.42 20.269V24H116.12V19.294C116.12 18.6093 116.086 17.994 116.016 17.448H117.238L117.355 18.579C117.563 18.163 117.862 17.8467 118.252 17.63C118.651 17.4047 119.102 17.292 119.604 17.292ZM125.659 18.462V21.751C125.659 22.2017 125.755 22.5223 125.945 22.713C126.145 22.895 126.418 22.986 126.764 22.986C126.99 22.986 127.219 22.9513 127.453 22.882V23.948C127.167 24.0433 126.842 24.091 126.478 24.091C125.802 24.091 125.278 23.9003 124.905 23.519C124.533 23.1377 124.346 22.583 124.346 21.855V18.462H123.072V17.448H124.346V15.81L125.659 15.355V17.448H127.466V18.462H125.659ZM132.522 14.744H135.759C137.258 14.744 138.42 15.147 139.243 15.953C140.066 16.759 140.478 17.8943 140.478 19.359C140.478 20.8323 140.066 21.9763 139.243 22.791C138.42 23.597 137.258 24 135.759 24H132.522V14.744ZM135.681 22.882C137.96 22.882 139.1 21.7077 139.1 19.359C139.1 17.0277 137.96 15.862 135.681 15.862H133.861V22.882H135.681ZM147.913 20.75H143.233C143.276 22.284 143.974 23.051 145.326 23.051C146.08 23.051 146.769 22.804 147.393 22.31L147.796 23.246C147.501 23.506 147.124 23.714 146.665 23.87C146.214 24.0173 145.759 24.091 145.3 24.091C144.251 24.091 143.428 23.792 142.83 23.194C142.232 22.5873 141.933 21.7597 141.933 20.711C141.933 20.0437 142.063 19.45 142.323 18.93C142.592 18.41 142.964 18.007 143.441 17.721C143.918 17.435 144.459 17.292 145.066 17.292C145.95 17.292 146.643 17.578 147.146 18.15C147.657 18.722 147.913 19.515 147.913 20.529V20.75ZM145.092 18.267C144.598 18.267 144.195 18.4143 143.883 18.709C143.571 19.0037 143.372 19.424 143.285 19.97H146.756C146.704 19.4153 146.535 18.995 146.249 18.709C145.963 18.4143 145.577 18.267 145.092 18.267ZM151.189 18.462V21.751C151.189 22.2017 151.285 22.5223 151.475 22.713C151.675 22.895 151.948 22.986 152.294 22.986C152.52 22.986 152.749 22.9513 152.983 22.882V23.948C152.697 24.0433 152.372 24.091 152.008 24.091C151.332 24.091 150.808 23.9003 150.435 23.519C150.063 23.1377 149.876 22.583 149.876 21.855V18.462H148.602V17.448H149.876V15.81L151.189 15.355V17.448H152.996V18.462H151.189ZM160.332 17.448V24H159.032V22.882C158.841 23.272 158.555 23.571 158.174 23.779C157.801 23.987 157.364 24.091 156.861 24.091C156.28 24.091 155.769 23.9523 155.327 23.675C154.894 23.3977 154.556 23.0077 154.313 22.505C154.07 21.9937 153.949 21.4 153.949 20.724C153.949 20.048 154.07 19.45 154.313 18.93C154.564 18.41 154.911 18.007 155.353 17.721C155.795 17.435 156.298 17.292 156.861 17.292C157.364 17.292 157.801 17.4003 158.174 17.617C158.547 17.825 158.833 18.124 159.032 18.514V17.448H160.332ZM157.173 23.051C157.762 23.051 158.217 22.8473 158.538 22.44C158.867 22.024 159.032 21.4433 159.032 20.698C159.032 19.944 158.867 19.3633 158.538 18.956C158.217 18.5487 157.758 18.345 157.16 18.345C156.571 18.345 156.107 18.5573 155.769 18.982C155.44 19.398 155.275 19.9787 155.275 20.724C155.275 21.4607 155.44 22.0327 155.769 22.44C156.107 22.8473 156.575 23.051 157.173 23.051ZM162.391 17.448H163.691V24H162.391V17.448ZM163.795 14.588V15.966H162.274V14.588H163.795ZM165.745 14.432H167.045V24H165.745V14.432ZM171.388 24.091C170.244 24.091 169.343 23.8137 168.684 23.259L169.074 22.31C169.759 22.83 170.543 23.09 171.427 23.09C171.878 23.09 172.22 23.0163 172.454 22.869C172.688 22.713 172.805 22.4963 172.805 22.219C172.805 21.985 172.723 21.803 172.558 21.673C172.402 21.5343 172.133 21.4173 171.75"
										fill="white" />
								</svg>
							),
							onClick: this.uploadToEditFirstButton
						},
						documentReplaced: isReplaced
						// relatedDocuments: relatedDocuments
					};
				}

				this.setState({
					...newState,
					typeSelected: type.code,
					//validationSchema:this.props.formType === "uploadToEdit"?this.getValidationSchema(type.code).concat(validationsUploadToEdit):this.getValidationSchema(type.code),
					parentDocument
				});
			});

		} else {
			this.setState({ showLoading: false })
		}
	}

	setShowButtons = (button, validation) => {
		return this.setState({
			nextButton: button.nextButton,
			extraButton: button.extraButton,
			validationSchema: validation ? validation : this.state.validationSchema
		})
	}

	uploadToEditFirstButton = (values) => {
		return new Promise((resolve, reject) => {
			this.setState({
				showButtons:( this?.props?.formType === "uploadToEdit" && this?.props?.params?.templateId ) ? false : true,
				showSteps: false,
				validationSchema: this.props.formType === "uploadToEdit" ? this.getValidationSchema(this.props.params.docType).concat(validationsUploadToEdit) : this.getValidationSchema(this.props.params.docType),
				showLoading: false,
				forceNextStep: {
					step: 1,
					values
				},
				nextButton: {
					button: this.isGetSignatures() ? (
						<svg width="130" height="40" viewBox="0 0 130 40" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M0 4C0 1.79086 1.79086 0 4 0H126C128.209 0 130 1.79086 130 4V36C130 38.2091 128.209 40 126 40H4C1.79086 40 0 38.2091 0 36V4Z"
								fill="#2C74FF" />
							<path
								d="M41.4346 24.104C40.542 24.104 39.762 23.9133 39.0946 23.532C38.436 23.142 37.929 22.5917 37.5736 21.881C37.2183 21.1703 37.0406 20.3297 37.0406 19.359C37.0406 18.397 37.2183 17.5607 37.5736 16.85C37.929 16.1393 38.436 15.5933 39.0946 15.212C39.762 14.8307 40.542 14.64 41.4346 14.64C42.0673 14.64 42.6523 14.7397 43.1896 14.939C43.7356 15.1297 44.195 15.4113 44.5676 15.784L44.0996 16.772C43.6663 16.4167 43.2373 16.161 42.8126 16.005C42.3966 15.8403 41.9416 15.758 41.4476 15.758C40.4856 15.758 39.7403 16.07 39.2116 16.694C38.6916 17.318 38.4316 18.2063 38.4316 19.359C38.4316 20.5203 38.6916 21.4173 39.2116 22.05C39.7403 22.674 40.4856 22.986 41.4476 22.986C41.9416 22.986 42.3966 22.908 42.8126 22.752C43.2373 22.5873 43.6663 22.3273 44.0996 21.972L44.5676 22.96C44.195 23.3327 43.7356 23.6187 43.1896 23.818C42.6523 24.0087 42.0673 24.104 41.4346 24.104ZM48.9594 24.091C48.3181 24.091 47.7547 23.9523 47.2694 23.675C46.7841 23.3977 46.4071 23.0033 46.1384 22.492C45.8784 21.9807 45.7484 21.3827 45.7484 20.698C45.7484 20.0133 45.8784 19.4153 46.1384 18.904C46.4071 18.384 46.7841 17.9853 47.2694 17.708C47.7547 17.4307 48.3181 17.292 48.9594 17.292C49.5921 17.292 50.1511 17.4307 50.6364 17.708C51.1217 17.9853 51.4944 18.384 51.7544 18.904C52.0231 19.4153 52.1574 20.0133 52.1574 20.698C52.1574 21.3827 52.0231 21.9807 51.7544 22.492C51.4944 23.0033 51.1217 23.3977 50.6364 23.675C50.1511 23.9523 49.5921 24.091 48.9594 24.091ZM48.9464 23.051C49.5531 23.051 50.0167 22.8517 50.3374 22.453C50.6581 22.0543 50.8184 21.4693 50.8184 20.698C50.8184 19.944 50.6537 19.3633 50.3244 18.956C50.0037 18.5487 49.5487 18.345 48.9594 18.345C48.3614 18.345 47.8977 18.5487 47.5684 18.956C47.2391 19.3633 47.0744 19.944 47.0744 20.698C47.0744 21.4693 47.2347 22.0543 47.5554 22.453C47.8847 22.8517 48.3484 23.051 48.9464 23.051ZM57.3061 17.292C58.8748 17.292 59.6591 18.1673 59.6591 19.918V24H58.3461V19.996C58.3461 19.424 58.2335 19.008 58.0081 18.748C57.7915 18.488 57.4405 18.358 56.9551 18.358C56.4005 18.358 55.9541 18.5313 55.6161 18.878C55.2868 19.2247 55.1221 19.6883 55.1221 20.269V24H53.8221V19.294C53.8221 18.6093 53.7875 17.994 53.7181 17.448H54.9401L55.0571 18.579C55.2651 18.163 55.5641 17.8467 55.9541 17.63C56.3528 17.4047 56.8035 17.292 57.3061 17.292ZM63.3612 18.462V21.751C63.3612 22.2017 63.4565 22.5223 63.6472 22.713C63.8465 22.895 64.1195 22.986 64.4662 22.986C64.6915 22.986 64.9212 22.9513 65.1552 22.882V23.948C64.8692 24.0433 64.5442 24.091 64.1802 24.091C63.5042 24.091 62.9798 23.9003 62.6072 23.519C62.2345 23.1377 62.0482 22.583 62.0482 21.855V18.462H60.7742V17.448H62.0482V15.81L63.3612 15.355V17.448H65.1682V18.462H63.3612ZM66.5108 17.448H67.8108V24H66.5108V17.448ZM67.9148 14.588V15.966H66.3938V14.588H67.9148ZM73.3494 17.292C74.9181 17.292 75.7024 18.1673 75.7024 19.918V24H74.3894V19.996C74.3894 19.424 74.2768 19.008 74.0514 18.748C73.8348 18.488 73.4838 18.358 72.9984 18.358C72.4438 18.358 71.9974 18.5313 71.6594 18.878C71.3301 19.2247 71.1654 19.6883 71.1654 20.269V24H69.8654V19.294C69.8654 18.6093 69.8308 17.994 69.7614 17.448H70.9834L71.1004 18.579C71.3084 18.163 71.6074 17.8467 71.9974 17.63C72.3961 17.4047 72.8468 17.292 73.3494 17.292ZM83.3955 17.448V24H82.1215V22.908C81.9135 23.2893 81.6275 23.584 81.2635 23.792C80.8995 23.9913 80.4878 24.091 80.0285 24.091C78.4512 24.091 77.6625 23.2157 77.6625 21.465V17.448H78.9625V21.452C78.9625 21.9893 79.0708 22.388 79.2875 22.648C79.5128 22.8993 79.8508 23.025 80.3015 23.025C80.8388 23.025 81.2678 22.8517 81.5885 22.505C81.9178 22.1583 82.0825 21.699 82.0825 21.127V17.448H83.3955ZM91.0387 20.75H86.3587C86.402 22.284 87.0997 23.051 88.4517 23.051C89.2057 23.051 89.8947 22.804 90.5187 22.31L90.9217 23.246C90.627 23.506 90.25 23.714 89.7907 23.87C89.34 24.0173 88.885 24.091 88.4257 24.091C87.377 24.091 86.5537 23.792 85.9557 23.194C85.3577 22.5873 85.0587 21.7597 85.0587 20.711C85.0587 20.0437 85.1887 19.45 85.4487 18.93C85.7173 18.41 86.09 18.007 86.5667 17.721C87.0433 17.435 87.585 17.292 88.1917 17.292C89.0757 17.292 89.769 17.578 90.2717 18.15C90.783 18.722 91.0387 19.515 91.0387 20.529V20.75ZM88.2177 18.267C87.7237 18.267 87.3207 18.4143 87.0087 18.709C86.6967 19.0037 86.4973 19.424 86.4107 19.97H89.8817C89.8297 19.4153 89.6607 18.995 89.3747 18.709C89.0887 18.4143 88.703 18.267 88.2177 18.267Z"
								fill="white" />
						</svg>
					) : (
						<svg
							width="135"
							height="40"
							viewBox="0 0 135 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H131C132.933 0.5 134.5 2.067 134.5 4V36C134.5 37.933 132.933 39.5 131 39.5H4C2.06701 39.5 0.5 37.933 0.5 36V4Z"
								fill={"#2C74FF"}
							/>
							<path
								d="M43.108 25.104C42.3887 25.104 41.73 25.0087 41.132 24.818C40.5427 24.6273 40.0313 24.3413 39.598 23.96L40.079 22.972C40.5297 23.336 40.9977 23.6003 41.483 23.765C41.9683 23.9297 42.5143 24.012 43.121 24.012C43.8143 24.012 44.3517 23.882 44.733 23.622C45.1143 23.362 45.305 22.9937 45.305 22.517C45.305 22.1183 45.1273 21.8193 44.772 21.62C44.4167 21.412 43.8533 21.2213 43.082 21.048C42.3453 20.892 41.743 20.7143 41.275 20.515C40.807 20.307 40.4387 20.034 40.17 19.696C39.9013 19.3493 39.767 18.9073 39.767 18.37C39.767 17.8327 39.91 17.3603 40.196 16.953C40.482 16.537 40.885 16.2163 41.405 15.991C41.9337 15.757 42.5403 15.64 43.225 15.64C43.875 15.64 44.4817 15.7397 45.045 15.939C45.617 16.1383 46.0937 16.42 46.475 16.784L45.994 17.772C45.5693 17.4167 45.1317 17.1567 44.681 16.992C44.2303 16.8187 43.7493 16.732 43.238 16.732C42.5707 16.732 42.0463 16.875 41.665 17.161C41.2837 17.4383 41.093 17.8197 41.093 18.305C41.093 18.721 41.2577 19.0373 41.587 19.254C41.925 19.4707 42.4623 19.6657 43.199 19.839C43.9703 20.0123 44.5943 20.1943 45.071 20.385C45.5477 20.5757 45.929 20.8357 46.215 21.165C46.501 21.4943 46.644 21.919 46.644 22.439C46.644 22.9763 46.501 23.4443 46.215 23.843C45.929 24.2417 45.5173 24.5537 44.98 24.779C44.4513 24.9957 43.8273 25.104 43.108 25.104ZM54.3116 18.448V25H53.0116V23.882C52.8209 24.272 52.5349 24.571 52.1536 24.779C51.7809 24.987 51.3432 25.091 50.8406 25.091C50.2599 25.091 49.7486 24.9523 49.3066 24.675C48.8732 24.3977 48.5352 24.0077 48.2926 23.505C48.0499 22.9937 47.9286 22.4 47.9286 21.724C47.9286 21.048 48.0499 20.45 48.2926 19.93C48.5439 19.41 48.8906 19.007 49.3326 18.721C49.7746 18.435 50.2772 18.292 50.8406 18.292C51.3432 18.292 51.7809 18.4003 52.1536 18.617C52.5262 18.825 52.8122 19.124 53.0116 19.514V18.448H54.3116ZM51.1526 24.051C51.7419 24.051 52.1969 23.8473 52.5176 23.44C52.8469 23.024 53.0116 22.4433 53.0116 21.698C53.0116 20.944 52.8469 20.3633 52.5176 19.956C52.1969 19.5487 51.7376 19.345 51.1396 19.345C50.5502 19.345 50.0866 19.5573 49.7486 19.982C49.4192 20.398 49.2546 20.9787 49.2546 21.724C49.2546 22.4607 49.4192 23.0327 49.7486 23.44C50.0866 23.8473 50.5546 24.051 51.1526 24.051ZM62.3244 18.461L59.4774 25H58.2944L55.4734 18.461H56.8644L58.9184 23.518L61.0114 18.461H62.3244ZM68.9713 21.75H64.2913C64.3346 23.284 65.0323 24.051 66.3843 24.051C67.1383 24.051 67.8273 23.804 68.4513 23.31L68.8543 24.246C68.5596 24.506 68.1826 24.714 67.7233 24.87C67.2726 25.0173 66.8176 25.091 66.3583 25.091C65.3096 25.091 64.4863 24.792 63.8883 24.194C63.2903 23.5873 62.9913 22.7597 62.9913 21.711C62.9913 21.0437 63.1213 20.45 63.3813 19.93C63.65 19.41 64.0226 19.007 64.4993 18.721C64.976 18.435 65.5176 18.292 66.1243 18.292C67.0083 18.292 67.7016 18.578 68.2043 19.15C68.7156 19.722 68.9713 20.515 68.9713 21.529V21.75ZM66.1503 19.267C65.6563 19.267 65.2533 19.4143 64.9413 19.709C64.6293 20.0037 64.43 20.424 64.3433 20.97H67.8143C67.7623 20.4153 67.5933 19.995 67.3073 19.709C67.0213 19.4143 66.6356 19.267 66.1503 19.267ZM81.5618 25.117C80.8511 24.831 80.2315 24.4367 79.7028 23.934C79.3301 24.3067 78.9055 24.5927 78.4288 24.792C77.9608 24.9913 77.4581 25.091 76.9208 25.091C76.3141 25.091 75.7768 24.9913 75.3088 24.792C74.8495 24.584 74.4898 24.2937 74.2298 23.921C73.9785 23.5483 73.8528 23.1193 73.8528 22.634C73.8528 22.0707 74.0131 21.568 74.3338 21.126C74.6631 20.684 75.1918 20.255 75.9198 19.839C75.5385 19.4143 75.2655 19.046 75.1008 18.734C74.9448 18.4133 74.8668 18.084 74.8668 17.746C74.8668 17.122 75.0878 16.6193 75.5298 16.238C75.9718 15.848 76.5481 15.653 77.2588 15.653C77.9261 15.653 78.4548 15.8263 78.8448 16.173C79.2435 16.5197 79.4428 16.9877 79.4428 17.577C79.4428 18.045 79.3041 18.461 79.0268 18.825C78.7495 19.189 78.2771 19.579 77.6098 19.995L79.6378 22.205C80.0191 21.451 80.2271 20.554 80.2618 19.514H81.3928C81.3408 20.9007 81.0115 22.0793 80.4048 23.05C80.9075 23.544 81.5228 23.934 82.2508 24.22L81.5618 25.117ZM77.2718 16.602C76.9251 16.602 76.6435 16.706 76.4268 16.914C76.2101 17.122 76.1018 17.395 76.1018 17.733C76.1018 17.9583 76.1581 18.1793 76.2708 18.396C76.3921 18.604 76.6131 18.8943 76.9338 19.267C77.4625 18.9463 77.8265 18.669 78.0258 18.435C78.2251 18.1923 78.3248 17.928 78.3248 17.642C78.3248 17.33 78.2295 17.0787 78.0388 16.888C77.8481 16.6973 77.5925 16.602 77.2718 16.602ZM76.9598 24.064C77.7311 24.064 78.4028 23.765 78.9748 23.167L76.5958 20.58C76.0758 20.9093 75.7031 21.2257 75.4778 21.529C75.2525 21.8323 75.1398 22.179 75.1398 22.569C75.1398 23.0197 75.3045 23.3837 75.6338 23.661C75.9631 23.9297 76.4051 24.064 76.9598 24.064ZM90.9262 25.104C90.0335 25.104 89.2535 24.9133 88.5862 24.532C87.9275 24.142 87.4205 23.5917 87.0652 22.881C86.7098 22.1703 86.5322 21.3297 86.5322 20.359C86.5322 19.397 86.7098 18.5607 87.0652 17.85C87.4205 17.1393 87.9275 16.5933 88.5862 16.212C89.2535 15.8307 90.0335 15.64 90.9262 15.64C91.5588 15.64 92.1438 15.7397 92.6812 15.939C93.2272 16.1297 93.6865 16.4113 94.0592 16.784L93.5912 17.772C93.1578 17.4167 92.7288 17.161 92.3042 17.005C91.8882 16.8403 91.4332 16.758 90.9392 16.758C89.9772 16.758 89.2318 17.07 88.7032 17.694C88.1832 18.318 87.9232 19.2063 87.9232 20.359C87.9232 21.5203 88.1832 22.4173 88.7032 23.05C89.2318 23.674 89.9772 23.986 90.9392 23.986C91.4332 23.986 91.8882 23.908 92.3042 23.752C92.7288 23.5873 93.1578 23.3273 93.5912 22.972L94.0592 23.96C93.6865 24.3327 93.2272 24.6187 92.6812 24.818C92.1438 25.0087 91.5588 25.104 90.9262 25.104ZM95.7569 15.432H97.0569V25H95.7569V15.432ZM101.932 25.091C101.291 25.091 100.728 24.9523 100.242 24.675C99.7572 24.3977 99.3802 24.0033 99.1115 23.492C98.8515 22.9807 98.7215 22.3827 98.7215 21.698C98.7215 21.0133 98.8515 20.4153 99.1115 19.904C99.3802 19.384 99.7572 18.9853 100.242 18.708C100.728 18.4307 101.291 18.292 101.932 18.292C102.565 18.292 103.124 18.4307 103.609 18.708C104.095 18.9853 104.467 19.384 104.727 19.904C104.996 20.4153 105.13 21.0133 105.13 21.698C105.13 22.3827 104.996 22.9807 104.727 23.492C104.467 24.0033 104.095 24.3977 103.609 24.675C103.124 24.9523 102.565 25.091 101.932 25.091ZM101.919 24.051C102.526 24.051 102.99 23.8517 103.31 23.453C103.631 23.0543 103.791 22.4693 103.791 21.698C103.791 20.944 103.627 20.3633 103.297 19.956C102.977 19.5487 102.522 19.345 101.932 19.345C101.334 19.345 100.871 19.5487 100.541 19.956C100.212 20.3633 100.047 20.944 100.047 21.698C100.047 22.4693 100.208 23.0543 100.528 23.453C100.858 23.8517 101.321 24.051 101.919 24.051ZM109.083 25.091C107.939 25.091 107.038 24.8137 106.379 24.259L106.769 23.31C107.454 23.83 108.238 24.09 109.122 24.09C109.573 24.09 109.915 24.0163 110.149 23.869C110.383 23.713 110.5 23.4963 110.5 23.219C110.5 22.985 110.418 22.803 110.253 22.673C110.097 22.5343 109.829 22.4173 109.447 22.322L108.355 22.062C107.783 21.9407 107.346 21.7283 107.042 21.425C106.748 21.113 106.6 20.7273 106.6 20.268C106.6 19.6787 106.834 19.202 107.302 18.838C107.779 18.474 108.407 18.292 109.187 18.292C109.655 18.292 110.097 18.3657 110.513 18.513C110.938 18.6603 111.298 18.8683 111.592 19.137L111.189 20.06C110.557 19.5573 109.889 19.306 109.187 19.306C108.763 19.306 108.433 19.3883 108.199 19.553C107.965 19.709 107.848 19.93 107.848 20.216C107.848 20.4413 107.922 20.6233 108.069 20.762C108.217 20.9007 108.451 21.009 108.771 21.087L109.889 21.36C110.513 21.4987 110.973 21.7197 111.267 22.023C111.571 22.3177 111.722 22.7033 111.722 23.18C111.722 23.7693 111.484 24.2373 111.007 24.584C110.539 24.922 109.898 25.091 109.083 25.091ZM118.99 21.75H114.31C114.353 23.284 115.051 24.051 116.403 24.051C117.157 24.051 117.846 23.804 118.47 23.31L118.873 24.246C118.578 24.506 118.201 24.714 117.742 24.87C117.291 25.0173 116.836 25.091 116.377 25.091C115.328 25.091 114.505 24.792 113.907 24.194C113.309 23.5873 113.01 22.7597 113.01 21.711C113.01 21.0437 113.14 20.45 113.4 19.93C113.668 19.41 114.041 19.007 114.518 18.721C114.994 18.435 115.536 18.292 116.143 18.292C117.027 18.292 117.72 18.578 118.223 19.15C118.734 19.722 118.99 20.515 118.99 21.529V21.75ZM116.169 19.267C115.675 19.267 115.272 19.4143 114.96 19.709C114.648 20.0037 114.448 20.424 114.362 20.97H117.833C117.781 20.4153 117.612 19.995 117.326 19.709C117.04 19.4143 116.654 19.267 116.169 19.267Z"
								fill={'white'}
							/>
							<path
								d="M15.5 14C15.5 13.7239 15.7239 13.5 16 13.5H26.5858C26.7184 13.5 26.8456 13.5527 26.9393 13.6464L28.3536 15.0607C28.4473 15.1544 28.5 15.2816 28.5 15.4142V26C28.5 26.2761 28.2761 26.5 28 26.5H16C15.7239 26.5 15.5 26.2761 15.5 26V14Z"
								fill="white"
								stroke="#BEC9D7"
							/>
							<path
								d="M18 13.6364V19C18 19.5523 18.4477 20 19 20H25C25.5523 20 26 19.5523 26 19V13"
								stroke={"#2C74FF"}
							/>
							<rect
								x="19.5"
								y="23.5"
								width="5"
								height="3"
								rx="0.5"
								fill="white"
								stroke={"#2C74FF"}
							/>
						</svg>
					),
					disabled: this.handleDisabled(values),
					onClick: this.isGetSignatures() ? this.getSignatures : this.saveAndClose
				}
			}, (result) => {
				resolve();
			});
		})
	};

	generateAgreement = async (values, isEdit) => {
		if (isEdit) {
			this.setState(state => ({
				showButtons: false,
				showSteps: false,
				forceNextStep: {
					step: 1 + state.plusToStep,
					values
				}
			}));
		} else {
			this.setState({
				showButtons: false,
				showSteps: false
			});
		}

		const agreementData = this.agreementDataByDocumentType(stripTypenames(values))
		const extraValues = await SaveByForm(this.state.typeSelected, agreementData)
		this.setState({
			extraValues
		})
		const agreementDataWithExtraValues = this.agreementDataByDocumentType(stripTypenames(values),extraValues)
		const data = {
			agreementData:agreementDataWithExtraValues
		};

		return ServerConnect.graphQlMutation(previewAgreement, data).then(
			result => {
				this.setState({
					showButtons: false,
					footer: undefined,
					footerStep3: this.getStep3Footer(result,
						{
							...values,
							file: result.getPreviewAgreementDocument.file
						}),
					showSteps: false,
					file: result.getPreviewAgreementDocument.file,
					generatedAgreements: result.getPreviewAgreementDocument.generatedDocuments,
					// forceNextStep: {...this.state.forceNextStep, values: data}
				});

				this.props.refreshProfile(this.props.session.startup)

				return result;
			}
		);
	};

	agreementDataByDocumentType = (values) => { // values => Formik
		const params = values.file ? _.omit(values, ['file']) : values;
		const groupCompany = this.getPartiesType(values.documentType)?.partyGroupCompany?.party
		//FIX: CP 9648
		if(values[groupCompany]){
			const gc = this.state.groupCompaniesList.find(gc=>gc.id===values[groupCompany].id)
			 _.set(values[groupCompany],'type',gc?.managedByClara?gc?.type:values[groupCompany].type)
		}
		let stakeholderOtherJurisdiction;
		let companyOtherJurisdiction;
		// console.log(values,'values')
		switch (values.documentType) {
			case "FOUNDERS_TERM_SHEET":
				return {
					documentType: values.documentType,
					agreementName: values.agreementName,
					expirationDate: values.expirationDate,
					params: params
				};
			case "IP_ASSIGNMENT":
				this.updateAuthorizedSignatories(values.assignee.authorizedSignatories);
				stakeholderOtherJurisdiction = values.assignor.otherJurisdiction;
				delete values.assignor.otherJurisdiction;

				companyOtherJurisdiction = values.assignee.otherJurisdiction;
				delete values.assignee.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					assignor: {
						...values.assignor,
						email: values.assignor.isAnEntity
							? values.assignor.authorizedSignatory.email
							: values.assignor.email,
						nationality: !_.isEmpty(values.assignor.nationality.code)
							? values.assignor.nationality.code
							: values.assignor.nationality,
						jurisdiction: values.assignor.jurisdiction === "OTHER"
							? stakeholderOtherJurisdiction
							: values.assignor.jurisdiction,
						address: {
							...values.assignor.address,
							country: !_.isEmpty(_.get(values, 'assignor.address.country.code', ''))
								? values.assignor.address.country.code
								: values.assignor.address.country
						},
						recipientNotice: values.assignor.isAnEntity ? {
							...values.assignor.recipientNotice,
							address: {
								...values.assignor.recipientNotice.address,
								country: !_.isEmpty(_.get(values, 'assignor.recipientNotice.address.country.code', ''))
									? values.assignor.recipientNotice.address.country.code
									: values.assignor.recipientNotice.address.country
							}
						} : null
					},
					assignee: {
						id: values.assignee.id,
						name: values.assignee.name,
						authorizedSignatories: values.assignee.authorizedSignatories
							.map(as => ({ id: as.id, email: as.email })),
						country: !_.isEmpty(values.assignee.country.code)
							? values.assignee.country.code
							: values.assignee.country,
						jurisdiction: values.assignee.jurisdiction === "OTHER"
							? companyOtherJurisdiction
							: values.assignee.jurisdiction,
						registeredAddress: {
							..._.omit(values.assignee.registeredAddress, '_id'),
							country: !_.isEmpty(values.assignee.registeredAddress.country.code)
								? values.assignee.registeredAddress.country.code
								: values.assignee.registeredAddress.country
						},
						recipientNotice: values.assignee.recipientNotice.address && values.assignee.recipientNotice.email
							? {
								fullName: values.assignee.recipientNotice.fullName,
								email: values.assignee.recipientNotice.email,
								address: {
									...values.assignee.recipientNotice.address,
									country: !_.isEmpty(values.assignee.recipientNotice.address.country.code)
										? values.assignee.recipientNotice.address.country.code
										: values.assignee.recipientNotice.address.country
								}
							} : {
								...values.assignee.recipientNotice,
								address: {
									...values.assignee.recipientNotice.address,
									country: !_.isEmpty(values.assignee.recipientNotice.address.country.code)
										? values.assignee.recipientNotice.address.country.code
										: values.assignee.recipientNotice.address.country
								}
							}
					},
					params: {
						...params,
						...values,
						assignor: {
							...values.assignor,
							email: values.assignor.isAnEntity
								? values.assignor.authorizedSignatory.email
								: values.assignor.email,
							nationality: !_.isEmpty(values.assignor.nationality.code)
								? values.assignor.nationality.code
								: values.assignor.nationality,
							jurisdiction: values.assignor.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.assignor.jurisdiction,
							address: {
								...values.assignor.address,
								country: !_.isEmpty(values.assignor.address.country.code)
									? values.assignor.address.country.code
									: values.assignor.address.country
							},
							recipientNotice: values.assignor.isAnEntity ? {
								...values.assignor.recipientNotice,
								address: {
									...values.assignor.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'assignor.recipientNotice.address.country.code', ''))
										? values.assignor.recipientNotice.address.country.code
										: values.assignor.recipientNotice.address.country
								}
							} : null
						},
						assignee: {
							...values.assignee,
							authorizedSignatories: values.assignee.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.assignee.country.code)
								? values.assignee.country.code
								: values.assignee.country,
							jurisdiction: values.assignee.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.assignee.jurisdiction,
							registeredAddress: {
								...values.assignee.registeredAddress,
								country: !_.isEmpty(values.assignee.registeredAddress.country.code)
									? values.assignee.registeredAddress.country.code
									: values.assignee.registeredAddress.country
							},
							recipientNotice: {
								...values.assignee.recipientNotice,
								address: {
									...values.assignee.recipientNotice.address,
									country: !_.isEmpty(values.assignee.recipientNotice.address.country.code)
										? values.assignee.recipientNotice.address.country.code
										: values.assignee.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "SAFE":
			case "CONVERTIBLE_NOTE":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.investor.otherJurisdiction;
				delete values.investor.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						investor: {
							...values.investor,
							email: values.investor.isAnEntity
								? values.investor.authorizedSignatory.email
								: values.investor.email,
							nationality: !_.isEmpty(values.investor.nationality.code)
								? values.investor.nationality.code
								: values.investor.nationality,
							jurisdiction: values.investor.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.investor.jurisdiction,
							address: {
								...values.investor.address,
								country: !_.isEmpty(values.investor.address.country.code)
									? values.investor.address.country.code
									: values.investor.address.country
							},
							recipientNotice: values.investor.isAnEntity ? {
								...values.investor.recipientNotice,
								address: {
									...values.investor.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'investor.recipientNotice.address.country.code', ''))
										? values.investor.recipientNotice.address.country.code
										: _.get(values, 'investor.recipientNotice.address.country', '')
								}
							} : null
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						},
						terms: {
							...values.terms,
							bankInfo: {
								...values.terms.bankInfo,
								id: values.terms.bankInfo.id || this.state.extraValues?.id
							}
						}
					}
				};
			case "ADVISOR_AGREEMENT":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.advisor.otherJurisdiction;
				delete values.advisor.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						advisor: {
							...values.advisor,
							email: values.advisor.isAnEntity
								? values.advisor.authorizedSignatory.email
								: values.advisor.email,
							nationality: !_.isEmpty(values.advisor.nationality.code)
								? values.advisor.nationality.code
								: values.advisor.nationality,
							jurisdiction: values.advisor.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.advisor.jurisdiction,
							address: {
								...values.advisor.address,
								country: !_.isEmpty(values.advisor.address.country.code)
									? values.advisor.address.country.code
									: values.advisor.address.country
							},
							recipientNotice: values.advisor.isAnEntity ? {
								...values.advisor.recipientNotice,
								address: {
									...values.advisor.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'advisor.recipientNotice.address.country.code', ''))
										? values.advisor.recipientNotice.address.country.code
										: _.get(values, 'advisor.recipientNotice.address.country', '')
								}
							} : null
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.employee.otherJurisdiction;
				delete values.employee.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						employee: {
							...values.employee,
							email: values.employee.isAnEntity
								? values.employee.authorizedSignatory.email
								: values.employee.email,
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName, title: as.title })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
						}
					}
				};
			case "USA_STRATEGIC_ADVISORY_BOARD_LETTER":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.advisor.otherJurisdiction;
				delete values.advisor.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						advisor: {
							// ...values.advisor,
							email: values.advisor.isAnEntity
								? values.advisor.authorizedSignatory.email
								: values.advisor.email,
							fullName: values.advisor.fullName,
							id: values.advisor.id
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName, title: as.title })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
						}
					}
				};
			case "USA_CONSULTANT_INFORMATION_AND_INVENTIONS_AGREEMENT":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.consultant.otherJurisdiction;
				delete values.consultant.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						consultant: {
							...values.consultant,
							email: values.consultant.isAnEntity
								? values.consultant.authorizedSignatory.email
								: values.consultant.email,
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName, title: as.title })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
						}
					}
				};
			case "CONSULTANT_AGREEMENT":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.consultant.otherJurisdiction;
				delete values.consultant.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						consultant: {
							...values.consultant,
							email: values.consultant.isAnEntity
								? values.consultant.authorizedSignatory.email
								: values.consultant.email,
							nationality: !_.isEmpty(values.consultant.nationality.code)
								? values.consultant.nationality.code
								: values.consultant.nationality,
							nationalityName: !_.isEmpty(values.consultant.nationality.name)
								? values.consultant.nationality.name
								: values.consultant.nationality,
							jurisdiction: values.consultant.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.consultant.jurisdiction,
							address: {
								...values.consultant.address,
								country: !_.isEmpty(values.consultant.address.country.code)
									? values.consultant.address.country.code
									: values.consultant.address.country
							},
							recipientNotice: values.consultant.isAnEntity ? {
								...values.consultant.recipientNotice,
								address: {
									...values.consultant.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'consultant.recipientNotice.address.country.code', ''))
										? values.consultant.recipientNotice.address.country.code
										: _.get(values, 'consultant.recipientNotice.address.country', '')
								}
							} : null
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "FOUNDER_SERVICES_AGREEMENT":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);

				stakeholderOtherJurisdiction = values.founder.otherJurisdiction;
				delete values.founder.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				const otherResponsibility = values.founder.position.otherResponsibility;
				delete values.founder.position.otherResponsibility

				const otherResponsibilitiesCode = values.founder.position.otherResponsibilitiesCode;
				delete values.founder.position.otherResponsibilitiesCode

				const otherResponsibilities = values.founder.position.otherResponsibilities;
				delete values.founder.position.otherResponsibilities

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						founder: {
							...values.founder,
							share: values.founder.isThereVesting ? values.founder.share.map(sh => ({
								...sh,
								vestingTerms: {
									...sh.vestingTerms,
									vestingTermId: this.state.extraValues?.vestingTerm?.id || sh.vestingTerms?.id
								},
								shareClass: {
									...sh.shareClass,
									isGenerated: this.state.extraValues?.shareClass?.isGenerated,
									id: this.state.extraValues?.shareClass?.id || sh.shareClass.id
								}
							})) : null,
							email: values.founder.isAnEntity
								? values.founder.authorizedSignatory.email
								: values.founder.email,
							nationality: !_.isEmpty(values.founder.nationality.code)
								? values.founder.nationality.code
								: values.founder.nationality,
							nationalityName: !_.isEmpty(values.founder.nationality.name)
								? values.founder.nationality.name
								: values.founder.nationality,
							jurisdiction: values.founder.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.founder.jurisdiction,
							address: {
								...values.founder.address,
								country: !_.isEmpty(values.founder.address.country.code)
									? values.founder.address.country.code
									: values.founder.address.country
							},
							position: {
								...values.founder.position,
								responsibilities: values.founder.position.isDefault
									? _.map(values.founder.position.responsibilities, responsibility => {
										return responsibility.isDefault
											? { ...responsibility }
											: { ...responsibility, text: otherResponsibility, name: otherResponsibility }
									})
									: [{
										code: otherResponsibilitiesCode,
										name: otherResponsibilities,
										text: otherResponsibilities,
										isDefault: false
									}]
							},
							recipientNotice: values.founder.isAnEntity ? {
								...values.founder.recipientNotice,
								address: {
									...values.founder.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'founder.recipientNotice.address.country.code', ''))
										? values.founder.recipientNotice.address.country.code
										: _.get(values, 'founder.recipientNotice.address.country', '')
								}
							} : null
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "FOUNDERS_AGREEMENT":
				this.updateAuthorizedSignatories(_.get(values.company, 'authorizedSignatories', []));
				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				delete values.company.verified1;
				delete values.company.verified2;
				delete values.company.showTopLevelOption

				_.get(params, 'terms.transferShares.transferSharesGroupCompanies') &&
					_.forEach(_.get(params, 'terms.transferShares.companies', []), (company) => {
						delete company.verified
						delete company.showTopLevelOption
					});
				params.terms.directors.appointDirectors = 'holdsShares'; // set default by request CP-3824;
				params.terms.directors.chairPersonHavesVote = false; // set default by request CP-3824

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						founders: _.map(values.founders, founder => {
							const otherJurisdiction = founder.otherJurisdiction;
							delete founder.otherJurisdiction;
							delete founder.verified1;
							delete founder.verified2;
							delete founder.startupPosition;

							const otherResponsibility = founder.position.otherResponsibility;
							delete founder.position.otherResponsibility

							const otherResponsibilitiesCode = founder.position.otherResponsibilitiesCode;
							delete founder.position.otherResponsibilitiesCode

							const otherResponsibilities = founder.position.otherResponsibilities;
							delete founder.position.otherResponsibilities

							const share = _.map(founder.share, (sh, index) => {
								if (index === 0) {
									const vestingTermsShareClass = (this.state.extraValues || []).find(s => s.founderId === founder.id)
									return {
										...sh,
										vestingTerms: { ...sh.vestingTerms, vestingTermId: vestingTermsShareClass?.vestingTerm?.id || sh.vestingTerms?.id },
										shareClass: { ...sh.shareClass, isGenerate: vestingTermsShareClass?.shareClass?.isGenerated, id: vestingTermsShareClass?.shareClass?.id || sh.shareClass.id }
									}
								}
								return sh
							})

							return {
								...founder,
								share,
								email: founder.isAnEntity
									? founder.authorizedSignatory.email
									: founder.email,
								nationality: !_.isEmpty(founder.nationality.code)
									? founder.nationality.code
									: founder.nationality,
								nationalityName: !_.isEmpty(founder.nationality.name)
									? founder.nationality.name
									: founder.nationality,
								jurisdiction:
									founder.jurisdiction === "OTHER"
										? otherJurisdiction
										: founder.jurisdiction,
								address: {
									...founder.address,
									country: !_.isEmpty(founder.address.country.code)
										? founder.address.country.code
										: founder.address.country
								},
								position: {
									...founder.position,
									responsibilities: founder.position.isDefault
										? _.map(founder.position.responsibilities, responsibility => {
											return responsibility.isDefault
												? { ...responsibility }
												: {
													...responsibility,
													text: otherResponsibility,
													name: otherResponsibility
												}
										})
										: [{
											code: otherResponsibilitiesCode,
											name: otherResponsibilities,
											text: otherResponsibilities,
											isDefault: false
										}]
								}
							}
						}),
						company: values.company.id !== 'groupCompanyNotSelected' ? {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						} : null,
						companyNotEstablished: values.company.id === 'groupCompanyNotSelected' ? {
							...values.company
						} : null
					}
				};
			case "EMPLOYMENT_AGREEMENT_ADGM":
			case "EMPLOYMENT_AGREEMENT_DIFC":
			case "EMPLOYMENT_AGREEMENT_UK":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.employee.otherJurisdiction;
				delete values.employee.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						employee: {
							...values.employee,
							email: values.employee.isAnEntity
								? values.employee.authorizedSignatory.email
								: values.employee.email,
							nationality: !_.isEmpty(values.employee.nationality.code)
								? values.employee.nationality.code
								: values.employee.nationality,
							nationalityName: !_.isEmpty(values.employee.nationality.name)
								? values.employee.nationality.name
								: values.employee.nationality,
							jurisdiction: values.employee.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.employee.jurisdiction,
							address: {
								...values.employee.address,
								country: !_.isEmpty(values.employee.address.country.code)
									? values.employee.address.country.code
									: values.employee.address.country
							},
							recipientNotice: values.employee.isAnEntity ? {
								...values.employee.recipientNotice,
								address: {
									...values.employee.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'employee.recipientNotice.address.country.code', null))
										? values.employee.recipientNotice.address.country.code
										: _.get(values, 'employee.recipientNotice.address.country', null)
								}
							} : null
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "GRANT_AGREEMENT":

				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.participant.otherJurisdiction;
				delete values.participant.otherJurisdiction;
				delete values.terms.grant.sipValidationData

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						terms: {
							...params.terms,
							vesting: {
								...params.terms.vesting,
								vestingTermId: this.state.extraValues?.id || params.terms.vesting.id
							}
						},
						participant: {
							...values.participant,
							email: values.participant.isAnEntity
								? values.participant.authorizedSignatory.email
								: values.participant.email,
							nationality: !_.isEmpty(values.participant.nationality.code)
								? values.participant.nationality.code
								: values.participant.nationality,
							nationalityName: !_.isEmpty(values.participant.nationality.name)
								? values.participant.nationality.name
								: values.participant.nationality,
							jurisdiction: values.participant.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.participant.jurisdiction,
							address: {
								...values.participant.address,
								country: !_.isEmpty(values.participant.address.country.code)
									? values.participant.address.country.code
									: values.participant.address.country
							},
							recipientNotice: values.participant.isAnEntity ? {
								...values.participant.recipientNotice,
								address: {
									...values.participant.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'participant.recipientNotice.address.country.code', ''))
										? values.participant.recipientNotice.address.country.code
										: _.get(values, 'participant.recipientNotice.address.country', '')
								}
							} : null
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "USA_OPTION_GRANT_NOTICE":

				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						participant: {
							...values.participant,
						},
						terms: {
							...params.terms,
							vesting: {
								...params.terms.vesting,
								vestingTermId: this.state.extraValues?.id
							}
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({
									id: as.id,
									email: as.email,
									fullName: as.fullName,
									title: as.title
								})),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},

						}
					}
				};
			case "USA_BOARD_APPROVING_OPTION_GRANT":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				if (params.terms.A409Valuation.isItApproved) {
					delete params.terms.A409Valuation.isItByBoardOrFirstApproved
				} else {
					if (!params.terms.A409Valuation.isItByBoardOrFirstApproved) {
						delete params.terms.A409Valuation.valuationFirmName
						delete params.terms.A409Valuation.date
					}
				}
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						grantees: values.grantees.map((g, index) => ({ ...g, vesting: _.get(this.state, `extraValues[${index}].standardTerm`) ? { id: _.get(this.state, `extraValues[${index}].id`), ..._.get(this.state, `extraValues[${index}].standardTerm`), vestingStartDate: g.vesting.vestingStartDate } : g.vesting })),
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
						}
					}
				}
			case "BOARD_RESOLUTION":
			case "SHARE_INCENTIVE_PLAN_FAQ":
			case "SHARE_INCENTIVE_PLAN":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "WEBSITE_COOKIE_NOTICE":
			case "WEBSITE_PRIVACY_POLICY":
			case "WEBSITE_ACCEPTABLE_USE_POLICY":
			case "WEBSITE_TERMS_OF_USE":
				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						company: {
							...values.company,
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
						}
					}
				};
			case "RESTRICTIVE_COVENANT_AGREEMENT":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.teamMember.otherJurisdiction;
				delete values.teamMember.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						teamMember: {
							...values.teamMember,
							email: values.teamMember.isAnEntity
								? values.teamMember.authorizedSignatory.email
								: values.teamMember.email,
							nationality: !_.isEmpty(values.teamMember.nationality.code)
								? values.teamMember.nationality.code
								: values.teamMember.nationality,
							nationalityName: !_.isEmpty(values.teamMember.nationality.name)
								? values.teamMember.nationality.name
								: values.teamMember.nationality,
							jurisdiction: values.teamMember.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.teamMember.jurisdiction,
							address: {
								...values.teamMember.address,
								country: !_.isEmpty(values.teamMember.address.country.code)
									? values.teamMember.address.country.code
									: values.teamMember.address.country
							},
							recipientNotice: values.teamMember.isAnEntity ? {
								...values.teamMember.recipientNotice,
								address: {
									...values.teamMember.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'teamMember.recipientNotice.address.country.code', ''))
										? values.teamMember.recipientNotice.address.country.code
										: _.get(values, 'teamMember.recipientNotice.address.country', '')
								}
							} : null
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "KISS":
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					expirationDate: values.expirationDate,
					params: params
				};
			case "NDA_MUTUAL":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.stakeholder.otherJurisdiction;
				delete values.stakeholder.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						stakeholder: {
							...values.stakeholder,
							email: values.stakeholder.isAnEntity
								? values.stakeholder.authorizedSignatory.email
								: values.stakeholder.email,
							nationality: !_.isEmpty(values.stakeholder.nationality.code)
								? values.stakeholder.nationality.code
								: values.stakeholder.nationality,
							nationalityName: !_.isEmpty(values.stakeholder.nationality.name)
								? values.stakeholder.nationality.name
								: values.stakeholder.nationality,
							jurisdiction: values.stakeholder.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.stakeholder.jurisdiction,
							address: {
								...values.stakeholder.address,
								country: !_.isEmpty(values.stakeholder.address.country.code)
									? values.stakeholder.address.country.code
									: values.stakeholder.address.country
							},
							recipientNotice: values.stakeholder.isAnEntity ? {
								...values.stakeholder.recipientNotice,
								address: {
									...values.stakeholder.recipientNotice.address,
									country: !_.isEmpty(_.get(values, 'stakeholder.recipientNotice.address.country.code', null))
										? values.stakeholder.recipientNotice.address.country.code
										: _.get(values, 'stakeholder.recipientNotice.address.country', null)
								}
							} : null
						},
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						}
					}
				};
			case "USA_BOARD_CONSENT_SAFE_CONVERTIBLE_LOAN_NOTE":
			case "USA_BOARD_CONSENT_SAFE_SAFE":
			case "USA_BOARD_CONSENT_SAFE_KISS":
			case "USA_BOARD_CONSENT_SAFE_FIXED_EQUITY":
			case "USA_BOARD_CONSENT_SAFE_OTHER":
			case "USA_BOARD_CONSENT_SAFE":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,

						}
					}
				};
			case "USA_EQUITY_INCENTIVE_PLAN":
			case "USA_STAKEHOLDERS_DIRECTORS_EQUITY_INCENTIVE_PLAN":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,

						},
						stakeholders: values.stakeholders
					}
				};
			case "USA_CONSULTING_AGREEMENT":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);
				stakeholderOtherJurisdiction = values.consultant.otherJurisdiction;
				delete values.consultant.otherJurisdiction;

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;
				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,

					params: {
						agreementName: values.agreementName,
						...params,
						company: {
							...(values?.company ?? {}),
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							authorizedSignatories: values.company.authorizedSignatories.map(auth => ({
								...auth,
								address: {
									...auth.address,
									country: auth.address?.country?.code || auth.address?.country
								}
							})),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							placeOfBusiness: {
								state: values.company.placeOfBusiness.state,
								city: values?.company?.placeOfBusiness?.city

							},
							recipientNotice: {
								...values.company.recipientNotice,
								address: {
									...values.company.recipientNotice.address,
									country: !_.isEmpty(values.company.recipientNotice.address.country.code)
										? values.company.recipientNotice.address.country.code
										: values.company.recipientNotice.address.country
								}
							}
						},
						consultant: {
							...(values?.consultant ?? {}),
							title: values.consultant.title,
							recipientNotice: {
								...values.consultant.recipientNotice,
								address: {
									...values.consultant.recipientNotice.address,
									country: !_.isEmpty(values.consultant.recipientNotice.address.country?.code)
										? values.consultant.recipientNotice.address.country.code
										: values.consultant.recipientNotice.address.country
								}
							},
							address: {
								...values.consultant.address,
								country: !_.isEmpty(values.consultant.address.country.code)
									? values.consultant.address.country.code
									: values.consultant.address.country
							},
							jurisdiction: values.consultant.jurisdiction === "OTHER"
								? stakeholderOtherJurisdiction
								: values.consultant.jurisdiction,
						}
					}
				};
			case "USA_NDA":

				this.updateAuthorizedSignatories(values.company.authorizedSignatories);

				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,

					params: {
						agreementName: values.agreementName,
						company: {
							...(values?.company ?? {}),
							authorizedSignatories: values.company.authorizedSignatories.map(auth => ({
								...auth,
								address: {
									...auth.address,
									country: auth.address?.country?.code || auth.address?.country
								}
							})),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							placeOfBusiness: {
								state: values.company.placeOfBusiness.state,
								city: values?.company?.placeOfBusiness?.city

							}
						},
						stakeholder: {
							...(values?.stakeholder ?? {}),
							title: values.stakeholder.title,
							address: {
								...values.stakeholder.address,
								country: !_.isEmpty(values.stakeholder.address.country.code)
									? values.stakeholder.address.country.code
									: values.stakeholder.address.country
							},
						},


					}
				};
			case "BOARD_RESOLUTION_CONVERTIBLE_LOAN_NOTE":
			case "BOARD_RESOLUTION_CONVERTIBLE_SAFE":
			case "BOARD_RESOLUTION_CONVERTIBLE_KISS":
			case "BOARD_RESOLUTION_CONVERTIBLE_FIXED_EQUITY":
			case "BOARD_RESOLUTION_CONVERTIBLE_OTHER":
			case "BOARD_RESOLUTION_CONVERTIBLE":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);

				companyOtherJurisdiction = values.company.otherJurisdiction;
				delete values.company.otherJurisdiction;


				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,
					params: {
						...params,
						company: {
							...values.company,
							authorizedSignatories: values.company.authorizedSignatories
								.map(as => ({ id: as.id, email: as.email, fullName: as.fullName })),
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							jurisdiction: values.company.jurisdiction === "OTHER"
								? companyOtherJurisdiction
								: values.company.jurisdiction,
							registeredAddress: {
								...values.company.registeredAddress,
								country: !_.isEmpty(values.company.registeredAddress.country.code)
									? values.company.registeredAddress.country.code
									: values.company.registeredAddress.country
							}
						}
					}
				};
			//CP-5321
			case "USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE":
				this.updateAuthorizedSignatories(values.company.authorizedSignatories);


				return {
					startupId: this.props.session.startup.id,
					documentType: values.documentType,
					agreementName: values.agreementName,

					params: {
						agreementName: values.agreementName,
						company: {
							...(values?.company ?? {}),
							authorizedSignatories: values.company.authorizedSignatories,
							country: !_.isEmpty(values.company.country.code)
								? values.company.country.code
								: values.company.country,
							placeOfBusiness: {
								state: values.company.placeOfBusiness.state,
								city: values?.company?.placeOfBusiness?.city

							}
						},
						stakeholder: {
							...(values?.stakeholder ?? {}),
							title: values.stakeholder.title,
							address: {
								...values.stakeholder.address,
								country: !_.isEmpty(values.stakeholder.address.country.code)
									? values.stakeholder.address.country.code
									: values.stakeholder.address.country
							},
						},
						terms: {
							...values.terms,
						}
					}
				};


			default:
				break;
		}

	};

	edit = (step, values) => {
		this.setState({
			forceNextStep: {
				step,
				values
			},
			showButtons: true,
			// showButtons: this.props.formType === "uploadToEdit" ? false : true,
			footer: undefined,
			showSteps: false,
			nextButton: {
				button: (
					<button style={{ 'width': '190px', 'height': '40px' }} data-cy="submit"
						className={`genericBlue`}>Generate Document</button>

				),
				onClick: this.generateAgreement
			}
		});


	};

	getExtension = (filename) => {
		let parts = filename.split('.');
		return parts[parts.length - 1];
	};

	redirectTableDocuments = ({ id }) => {
		this.props.goToPage(Constants.PAGES.viewDocumentGenerated, { id, status: "Draft" })

	}

	saveAndClose = values => {
		const documentReplaced = values.confirmSameData || this.state.documentReplaced;
		delete values.confirmSameData;


		this.setState({ showLoading: true });

		const data = {
			agreementId: _.get(this.props.params, "id", ""),
			agreement: {
				...this.agreementDataByDocumentType(stripTypenames(values)),
				file: this.state.file ? this.state.file : values.file,
				generatedDocuments: this.state.generatedAgreements,
				parentDocumentId: _.get(this, 'state.parentDocument.id', null),
				documentReplaced: documentReplaced
				// relatedDocuments: this.state.relatedDocuments
			},
			startupId: this.props.session.startup.id
		};
		return ServerConnect.graphQlMutation(generateAgreement, stripTypenames(data)).then(
			result => {
				//TODO REDUX: Remove when implements subscriptions

				const startupId = this.props.session.startup.id;

				event.emmit(Constants.EVENTS.REFRESH_ACTIVE_SUBSCRIPTION, { startupId })

				this.setState({
					showButtons: false,
					generatedAgreement: result,
					footer: undefined,
					footerStep3: this.getStep3Footer(result, values),
					showSteps: false
				});
				const docInfo = { agreementId: result.generateAgreement.id };
				const docInfoForNotification = { id: result.generateAgreement.id };
				this.props.goToPage(Constants.PAGES.documents, docInfo);
				notification.sendNotification(
					<React.Fragment>Your new document has been saved.
						<a onClick={() => this.redirectTableDocuments(docInfoForNotification)}>
							View Document
						</a>
					</React.Fragment>, "success", 5000);
				return result
			}
		);
	};

	getSignatures = values => {

		this.setState({
			forceNextStep: {
				step: 3 + this.state.plusToStep,
				values: {
					...values,
					file: this.state.file
				}
			},
			showButtons: false,
			footer: undefined,
			showSteps: false
		});

		// This query is here to show the loading page for a few seconds

		const stakeholderList = ` 
		${RoleFields}
		${NoticesFragment}
		${AuthorizedSignatoryFragment}
		{
                stakeholderList(startupId: "{{startupId}}") {
                    email
                    passportNumber
                    registeredNumber
                    nationality {name code}
                    jurisdiction
                    title
                    type
                    id
                    isAnEntity
                    address {
                        city
                        state
                        country {name code}
                        zipCode
                        street
                    }
                    fullName
                    roles { ...RoleFields }
                    phoneNumber
                    authorizedSignatory {...AuthorizedSignatoryFragment}
                    recipientNotice {...NoticesFragment}
            }
        }`;

		const queryParams = { startupId: this.props.session.startup.id };

		const query = Mustache.render(stakeholderList, queryParams);

		return ServerConnect.graphQlQuery(query).then(result => {
			this.setState({
				showButtons: true,
				// showButtons: this.props.formType === "uploadToEdit" ? false : true,
				showSteps: false,
				extraButton: null,
				nextButton: {
					button: (
						<svg
							width="180"
							height="40"
							viewBox="0 0 180 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0 4C0 1.79086 1.79086 0 4 0H176C178.209 0 180 1.79086 180 4V36C180 38.2091 178.209 40 176 40H4C1.79086 40 0 38.2091 0 36V4Z"
								fill="#2C74FF"
							/>
							<path
								d="M36.7719 24H35.3549L34.1979 20.919C34.0766 20.5897 33.8989 20.3643 33.6649 20.243C33.4309 20.113 33.1103 20.048 32.7029 20.048H30.6749V24H29.3489V14.744H33.1579C34.1719 14.744 34.9476 14.9693 35.4849 15.42C36.0309 15.8707 36.3039 16.5163 36.3039 17.357C36.3039 17.9637 36.1436 18.4793 35.8229 18.904C35.5023 19.3287 35.0473 19.6277 34.4579 19.801C34.9953 19.8963 35.3853 20.2777 35.6279 20.945L36.7719 24ZM33.0019 18.969C33.6779 18.969 34.1806 18.839 34.5099 18.579C34.8393 18.3103 35.0039 17.9117 35.0039 17.383C35.0039 16.8543 34.8393 16.4643 34.5099 16.213C34.1893 15.953 33.6866 15.823 33.0019 15.823H30.6749V18.969H33.0019ZM44.0164 20.75H39.3364C39.3797 22.284 40.0774 23.051 41.4294 23.051C42.1834 23.051 42.8724 22.804 43.4964 22.31L43.8994 23.246C43.6047 23.506 43.2277 23.714 42.7684 23.87C42.3177 24.0173 41.8627 24.091 41.4034 24.091C40.3547 24.091 39.5314 23.792 38.9334 23.194C38.3354 22.5873 38.0364 21.7597 38.0364 20.711C38.0364 20.0437 38.1664 19.45 38.4264 18.93C38.6951 18.41 39.0677 18.007 39.5444 17.721C40.0211 17.435 40.5627 17.292 41.1694 17.292C42.0534 17.292 42.7467 17.578 43.2494 18.15C43.7607 18.722 44.0164 19.515 44.0164 20.529V20.75ZM41.1954 18.267C40.7014 18.267 40.2984 18.4143 39.9864 18.709C39.6744 19.0037 39.4751 19.424 39.3884 19.97H42.8594C42.8074 19.4153 42.6384 18.995 42.3524 18.709C42.0664 18.4143 41.6807 18.267 41.1954 18.267ZM51.7501 17.448C51.6807 17.994 51.6461 18.6093 51.6461 19.294V26.808H50.3331V22.908C50.1337 23.2893 49.8477 23.584 49.4751 23.792C49.1024 23.9913 48.6691 24.091 48.1751 24.091C47.5944 24.091 47.0831 23.9523 46.6411 23.675C46.2077 23.3977 45.8697 23.0077 45.6271 22.505C45.3844 21.9937 45.2631 21.4 45.2631 20.724C45.2631 20.048 45.3844 19.45 45.6271 18.93C45.8784 18.41 46.2251 18.007 46.6671 17.721C47.1091 17.435 47.6117 17.292 48.1751 17.292C48.6951 17.292 49.1501 17.409 49.5401 17.643C49.9301 17.877 50.2161 18.2063 50.3981 18.631L50.5281 17.448H51.7501ZM48.4871 23.051C49.0764 23.051 49.5314 22.8473 49.8521 22.44C50.1814 22.024 50.3461 21.4433 50.3461 20.698C50.3461 19.944 50.1814 19.3633 49.8521 18.956C49.5314 18.5487 49.0721 18.345 48.4741 18.345C47.8847 18.345 47.4211 18.5573 47.0831 18.982C46.7537 19.398 46.5891 19.9787 46.5891 20.724C46.5891 21.4607 46.7537 22.0327 47.0831 22.44C47.4211 22.8473 47.8891 23.051 48.4871 23.051ZM59.399 17.448V24H58.125V22.908C57.917 23.2893 57.631 23.584 57.267 23.792C56.903 23.9913 56.4913 24.091 56.032 24.091C54.4546 24.091 53.666 23.2157 53.666 21.465V17.448H54.966V21.452C54.966 21.9893 55.0743 22.388 55.291 22.648C55.5163 22.8993 55.8543 23.025 56.305 23.025C56.8423 23.025 57.2713 22.8517 57.592 22.505C57.9213 22.1583 58.086 21.699 58.086 21.127V17.448H59.399ZM67.0421 20.75H62.3621C62.4055 22.284 63.1031 23.051 64.4551 23.051C65.2091 23.051 65.8981 22.804 66.5221 22.31L66.9251 23.246C66.6305 23.506 66.2535 23.714 65.7941 23.87C65.3435 24.0173 64.8885 24.091 64.4291 24.091C63.3805 24.091 62.5571 23.792 61.9591 23.194C61.3611 22.5873 61.0621 21.7597 61.0621 20.711C61.0621 20.0437 61.1921 19.45 61.4521 18.93C61.7208 18.41 62.0935 18.007 62.5701 17.721C63.0468 17.435 63.5885 17.292 64.1951 17.292C65.0791 17.292 65.7725 17.578 66.2751 18.15C66.7865 18.722 67.0421 19.515 67.0421 20.529V20.75ZM64.2211 18.267C63.7271 18.267 63.3241 18.4143 63.0121 18.709C62.7001 19.0037 62.5008 19.424 62.4141 19.97H65.8851C65.8331 19.4153 65.6641 18.995 65.3781 18.709C65.0921 18.4143 64.7065 18.267 64.2211 18.267ZM70.9668 24.091C69.8228 24.091 68.9215 23.8137 68.2628 23.259L68.6528 22.31C69.3375 22.83 70.1218 23.09 71.0058 23.09C71.4565 23.09 71.7988 23.0163 72.0328 22.869C72.2668 22.713 72.3838 22.4963 72.3838 22.219C72.3838 21.985 72.3015 21.803 72.1368 21.673C71.9808 21.5343 71.7122 21.4173 71.3308 21.322L70.2388 21.062C69.6668 20.9407 69.2292 20.7283 68.9258 20.425C68.6312 20.113 68.4838 19.7273 68.4838 19.268C68.4838 18.6787 68.7178 18.202 69.1858 17.838C69.6625 17.474 70.2908 17.292 71.0708 17.292C71.5388 17.292 71.9808 17.3657 72.3968 17.513C72.8215 17.6603 73.1812 17.8683 73.4758 18.137L73.0728 19.06C72.4402 18.5573 71.7728 18.306 71.0708 18.306C70.6462 18.306 70.3168 18.3883 70.0828 18.553C69.8488 18.709 69.7318 18.93 69.7318 19.216C69.7318 19.4413 69.8055 19.6233 69.9528 19.762C70.1002 19.9007 70.3342 20.009 70.6548 20.087L71.7728 20.36C72.3968 20.4987 72.8562 20.7197 73.1508 21.023C73.4542 21.3177 73.6058 21.7033 73.6058 22.18C73.6058 22.7693 73.3675 23.2373 72.8908 23.584C72.4228 23.922 71.7815 24.091 70.9668 24.091ZM76.9229 18.462V21.751C76.9229 22.2017 77.0183 22.5223 77.2089 22.713C77.4083 22.895 77.6813 22.986 78.028 22.986C78.2533 22.986 78.483 22.9513 78.717 22.882V23.948C78.4309 24.0433 78.1059 24.091 77.7419 24.091C77.0659 24.091 76.5416 23.9003 76.1689 23.519C75.7963 23.1377 75.6099 22.583 75.6099 21.855V18.462H74.3359V17.448H75.6099V15.81L76.9229 15.355V17.448H78.7299V18.462H76.9229ZM86.8144 24.104C86.0951 24.104 85.4364 24.0087 84.8384 23.818C84.2491 23.6273 83.7378 23.3413 83.3044 22.96L83.7854 21.972C84.2361 22.336 84.7041 22.6003 85.1894 22.765C85.6748 22.9297 86.2208 23.012 86.8274 23.012C87.5208 23.012 88.0581 22.882 88.4394 22.622C88.8208 22.362 89.0114 21.9937 89.0114 21.517C89.0114 21.1183 88.8338 20.8193 88.4784 20.62C88.1231 20.412 87.5598 20.2213 86.7884 20.048C86.0518 19.892 85.4494 19.7143 84.9814 19.515C84.5134 19.307 84.1451 19.034 83.8764 18.696C83.6078 18.3493 83.4734 17.9073 83.4734 17.37C83.4734 16.8327 83.6164 16.3603 83.9024 15.953C84.1884 15.537 84.5914 15.2163 85.1114 14.991C85.6401 14.757 86.2468 14.64 86.9314 14.64C87.5814 14.64 88.1881 14.7397 88.7514 14.939C89.3234 15.1383 89.8001 15.42 90.1814 15.784L89.7004 16.772C89.2758 16.4167 88.8381 16.1567 88.3874 15.992C87.9368 15.8187 87.4558 15.732 86.9444 15.732C86.2771 15.732 85.7528 15.875 85.3714 16.161C84.9901 16.4383 84.7994 16.8197 84.7994 17.305C84.7994 17.721 84.9641 18.0373 85.2934 18.254C85.6314 18.4707 86.1688 18.6657 86.9054 18.839C87.6768 19.0123 88.3008 19.1943 88.7774 19.385C89.2541 19.5757 89.6354 19.8357 89.9214 20.165C90.2074 20.4943 90.3504 20.919 90.3504 21.439C90.3504 21.9763 90.2074 22.4443 89.9214 22.843C89.6354 23.2417 89.2238 23.5537 88.6864 23.779C88.1578 23.9957 87.5338 24.104 86.8144 24.104ZM92.025 17.448H93.325V24H92.025V17.448ZM93.429 14.588V15.966H91.908V14.588H93.429ZM101.425 17.448V23.883C101.425 24.8797 101.16 25.6293 100.632 26.132C100.112 26.6433 99.3359 26.899 98.3046 26.899C97.3079 26.899 96.4369 26.6823 95.6916 26.249L95.9126 25.222C96.3199 25.4387 96.7099 25.599 97.0826 25.703C97.4639 25.807 97.8669 25.859 98.2916 25.859C99.5136 25.859 100.125 25.235 100.125 23.987V22.57C99.9253 22.9513 99.6349 23.2547 99.2536 23.48C98.8723 23.6967 98.4303 23.805 97.9276 23.805C97.3556 23.805 96.8443 23.6707 96.3936 23.402C95.9516 23.1333 95.6049 22.752 95.3536 22.258C95.1109 21.764 94.9896 21.1963 94.9896 20.555C94.9896 19.9137 95.1109 19.346 95.3536 18.852C95.6049 18.358 95.9516 17.9767 96.3936 17.708C96.8443 17.4307 97.3556 17.292 97.9276 17.292C98.4303 17.292 98.8723 17.4003 99.2536 17.617C99.6349 17.825 99.9253 18.124 100.125 18.514V17.448H101.425ZM98.2266 22.752C98.8159 22.752 99.2796 22.557 99.6176 22.167C99.9556 21.777 100.125 21.2397 100.125 20.555C100.125 19.8703 99.9556 19.333 99.6176 18.943C99.2883 18.5443 98.8246 18.345 98.2266 18.345C97.6373 18.345 97.1693 18.5443 96.8226 18.943C96.4846 19.333 96.3156 19.8703 96.3156 20.555C96.3156 21.231 96.4846 21.7683 96.8226 22.167C97.1693 22.557 97.6373 22.752 98.2266 22.752ZM106.966 17.292C108.535 17.292 109.319 18.1673 109.319 19.918V24H108.006V19.996C108.006 19.424 107.894 19.008 107.668 18.748C107.452 18.488 107.101 18.358 106.615 18.358C106.061 18.358 105.614 18.5313 105.276 18.878C104.947 19.2247 104.782 19.6883 104.782 20.269V24H103.482V19.294C103.482 18.6093 103.448 17.994 103.378 17.448H104.6L104.717 18.579C104.925 18.163 105.224 17.8467 105.614 17.63C106.013 17.4047 106.464 17.292 106.966 17.292ZM117.311 17.448V24H116.011V22.882C115.821 23.272 115.535 23.571 115.153 23.779C114.781 23.987 114.343 24.091 113.84 24.091C113.26 24.091 112.748 23.9523 112.306 23.675C111.873 23.3977 111.535 23.0077 111.292 22.505C111.05 21.9937 110.928 21.4 110.928 20.724C110.928 20.048 111.05 19.45 111.292 18.93C111.544 18.41 111.89 18.007 112.332 17.721C112.774 17.435 113.277 17.292 113.84 17.292C114.343 17.292 114.781 17.4003 115.153 17.617C115.526 17.825 115.812 18.124 116.011 18.514V17.448H117.311ZM114.152 23.051C114.742 23.051 115.197 22.8473 115.517 22.44C115.847 22.024 116.011 21.4433 116.011 20.698C116.011 19.944 115.847 19.3633 115.517 18.956C115.197 18.5487 114.737 18.345 114.139 18.345C113.55 18.345 113.086 18.5573 112.748 18.982C112.419 19.398 112.254 19.9787 112.254 20.724C112.254 21.4607 112.419 22.0327 112.748 22.44C113.086 22.8473 113.554 23.051 114.152 23.051ZM121.073 18.462V21.751C121.073 22.2017 121.169 22.5223 121.359 22.713C121.559 22.895 121.832 22.986 122.178 22.986C122.404 22.986 122.633 22.9513 122.867 22.882V23.948C122.581 24.0433 122.256 24.091 121.892 24.091C121.216 24.091 120.692 23.9003 120.319 23.519C119.947 23.1377 119.76 22.583 119.76 21.855V18.462H118.486V17.448H119.76V15.81L121.073 15.355V17.448H122.88V18.462H121.073ZM129.917 17.448V24H128.643V22.908C128.435 23.2893 128.149 23.584 127.785 23.792C127.421 23.9913 127.009 24.091 126.55 24.091C124.973 24.091 124.184 23.2157 124.184 21.465V17.448H125.484V21.452C125.484 21.9893 125.592 22.388 125.809 22.648C126.034 22.8993 126.372 23.025 126.823 23.025C127.36 23.025 127.789 22.8517 128.11 22.505C128.439 22.1583 128.604 21.699 128.604 21.127V17.448H129.917ZM135.233 17.292C135.432 17.292 135.64 17.3223 135.857 17.383L135.831 18.579C135.597 18.4923 135.341 18.449 135.064 18.449C134.466 18.449 134.015 18.631 133.712 18.995C133.417 19.3503 133.27 19.801 133.27 20.347V24H131.97V19.294C131.97 18.6093 131.935 17.994 131.866 17.448H133.088L133.205 18.631C133.378 18.1977 133.647 17.8683 134.011 17.643C134.375 17.409 134.782 17.292 135.233 17.292ZM142.451 20.75H137.771C137.814 22.284 138.512 23.051 139.864 23.051C140.618 23.051 141.307 22.804 141.931 22.31L142.334 23.246C142.039 23.506 141.662 23.714 141.203 23.87C140.752 24.0173 140.297 24.091 139.838 24.091C138.789 24.091 137.966 23.792 137.368 23.194C136.77 22.5873 136.471 21.7597 136.471 20.711C136.471 20.0437 136.601 19.45 136.861 18.93C137.129 18.41 137.502 18.007 137.979 17.721C138.455 17.435 138.997 17.292 139.604 17.292C140.488 17.292 141.181 17.578 141.684 18.15C142.195 18.722 142.451 19.515 142.451 20.529V20.75ZM139.63 18.267C139.136 18.267 138.733 18.4143 138.421 18.709C138.109 19.0037 137.909 19.424 137.823 19.97H141.294C141.242 19.4153 141.073 18.995 140.787 18.709C140.501 18.4143 140.115 18.267 139.63 18.267ZM146.375 24.091C145.231 24.091 144.33 23.8137 143.671 23.259L144.061 22.31C144.746 22.83 145.53 23.09 146.414 23.09C146.865 23.09 147.207 23.0163 147.441 22.869C147.675 22.713 147.792 22.4963 147.792 22.219C147.792 21.985 147.71 21.803 147.545 21.673C147.389 21.5343 147.121 21.4173 146.739 21.322L145.647 21.062C145.075 20.9407 144.638 20.7283 144.334 20.425C144.04 20.113 143.892 19.7273 143.892 19.268C143.892 18.6787 144.126 18.202 144.594 17.838C145.071 17.474 145.699 17.292 146.479 17.292C146.947 17.292 147.389 17.3657 147.805 17.513C148.23 17.6603 148.59 17.8683 148.884 18.137L148.481 19.06C147.849 18.5573 147.181 18.306 146.479 18.306C146.055 18.306 145.725 18.3883 145.491 18.553C145.257 18.709 145.14 18.93 145.14 19.216C145.14 19.4413 145.214 19.6233 145.361 19.762C145.509 19.9007 145.743 20.009 146.063 20.087L147.181 20.36C147.805 20.4987 148.265 20.7197 148.559 21.023C148.863 21.3177 149.014 21.7033 149.014 22.18C149.014 22.7693 148.776 23.2373 148.299 23.584C147.831 23.922 147.19 24.091 146.375 24.091Z"
								fill="white"
							/>
						</svg>
					),
					onClick: this.requestSignatures
				},
				backButton: {
					button: (

						<svg
							width="135"
							height="40"
							viewBox="0 0 135 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M4 0.5H131C132.933 0.5 134.5 2.167 134.5 4V36C134.5 37.933 132.933 39.5 131 39.5H4C2.06701 39.5 0.5 37.933 0.5 36V4C0.5 2.067 2.067 0.5 4 0.5Z"
								fill="white"
								stroke="#EAF1FE"
							/>
							<path
								d="M43.108 25.104C42.3887 25.104 41.73 25.0087 41.132 24.818C40.5427 24.6273 40.0313 24.3413 39.598 23.96L40.079 22.972C40.5297 23.336 40.9977 23.6003 41.483 23.765C41.9683 23.9297 42.5143 24.012 43.121 24.012C43.8143 24.012 44.3517 23.882 44.733 23.622C45.1143 23.362 45.305 22.9937 45.305 22.517C45.305 22.1183 45.1273 21.8193 44.772 21.62C44.4167 21.412 43.8533 21.2213 43.082 21.048C42.3453 20.892 41.743 20.7143 41.275 20.515C40.807 20.307 40.4387 20.034 40.17 19.696C39.9013 19.3493 39.767 18.9073 39.767 18.37C39.767 17.8327 39.91 17.3603 40.196 16.953C40.482 16.537 40.885 16.2163 41.405 15.991C41.9337 15.757 42.5403 15.64 43.225 15.64C43.875 15.64 44.4817 15.7397 45.045 15.939C45.617 16.1383 46.0937 16.42 46.475 16.784L45.994 17.772C45.5693 17.4167 45.1317 17.1567 44.681 16.992C44.2303 16.8187 43.7493 16.732 43.238 16.732C42.5707 16.732 42.0463 16.875 41.665 17.161C41.2837 17.4383 41.093 17.8197 41.093 18.305C41.093 18.721 41.2577 19.0373 41.587 19.254C41.925 19.4707 42.4623 19.6657 43.199 19.839C43.9703 20.0123 44.5943 20.1943 45.071 20.385C45.5477 20.5757 45.929 20.8357 46.215 21.165C46.501 21.4943 46.644 21.919 46.644 22.439C46.644 22.9763 46.501 23.4443 46.215 23.843C45.929 24.2417 45.5173 24.5537 44.98 24.779C44.4513 24.9957 43.8273 25.104 43.108 25.104ZM54.3116 18.448V25H53.0116V23.882C52.8209 24.272 52.5349 24.571 52.1536 24.779C51.7809 24.987 51.3432 25.091 50.8406 25.091C50.2599 25.091 49.7486 24.9523 49.3066 24.675C48.8732 24.3977 48.5352 24.0077 48.2926 23.505C48.0499 22.9937 47.9286 22.4 47.9286 21.724C47.9286 21.048 48.0499 20.45 48.2926 19.93C48.5439 19.41 48.8906 19.007 49.3326 18.721C49.7746 18.435 50.2772 18.292 50.8406 18.292C51.3432 18.292 51.7809 18.4003 52.1536 18.617C52.5262 18.825 52.8122 19.124 53.0116 19.514V18.448H54.3116ZM51.1526 24.051C51.7419 24.051 52.1969 23.8473 52.5176 23.44C52.8469 23.024 53.0116 22.4433 53.0116 21.698C53.0116 20.944 52.8469 20.3633 52.5176 19.956C52.1969 19.5487 51.7376 19.345 51.1396 19.345C50.5502 19.345 50.0866 19.5573 49.7486 19.982C49.4192 20.398 49.2546 20.9787 49.2546 21.724C49.2546 22.4607 49.4192 23.0327 49.7486 23.44C50.0866 23.8473 50.5546 24.051 51.1526 24.051ZM62.3244 18.461L59.4774 25H58.2944L55.4734 18.461H56.8644L58.9184 23.518L61.0114 18.461H62.3244ZM68.9713 21.75H64.2913C64.3346 23.284 65.0323 24.051 66.3843 24.051C67.1383 24.051 67.8273 23.804 68.4513 23.31L68.8543 24.246C68.5596 24.506 68.1826 24.714 67.7233 24.87C67.2726 25.0173 66.8176 25.091 66.3583 25.091C65.3096 25.091 64.4863 24.792 63.8883 24.194C63.2903 23.5873 62.9913 22.7597 62.9913 21.711C62.9913 21.0437 63.1213 20.45 63.3813 19.93C63.65 19.41 64.0226 19.007 64.4993 18.721C64.976 18.435 65.5176 18.292 66.1243 18.292C67.0083 18.292 67.7016 18.578 68.2043 19.15C68.7156 19.722 68.9713 20.515 68.9713 21.529V21.75ZM66.1503 19.267C65.6563 19.267 65.2533 19.4143 64.9413 19.709C64.6293 20.0037 64.43 20.424 64.3433 20.97H67.8143C67.7623 20.4153 67.5933 19.995 67.3073 19.709C67.0213 19.4143 66.6356 19.267 66.1503 19.267ZM81.5618 25.117C80.8511 24.831 80.2315 24.4367 79.7028 23.934C79.3301 24.3067 78.9055 24.5927 78.4288 24.792C77.9608 24.9913 77.4581 25.091 76.9208 25.091C76.3141 25.091 75.7768 24.9913 75.3088 24.792C74.8495 24.584 74.4898 24.2937 74.2298 23.921C73.9785 23.5483 73.8528 23.1193 73.8528 22.634C73.8528 22.0707 74.0131 21.568 74.3338 21.126C74.6631 20.684 75.1918 20.255 75.9198 19.839C75.5385 19.4143 75.2655 19.046 75.1008 18.734C74.9448 18.4133 74.8668 18.084 74.8668 17.746C74.8668 17.122 75.0878 16.6193 75.5298 16.238C75.9718 15.848 76.5481 15.653 77.2588 15.653C77.9261 15.653 78.4548 15.8263 78.8448 16.173C79.2435 16.5197 79.4428 16.9877 79.4428 17.577C79.4428 18.045 79.3041 18.461 79.0268 18.825C78.7495 19.189 78.2771 19.579 77.6098 19.995L79.6378 22.205C80.0191 21.451 80.2271 20.554 80.2618 19.514H81.3928C81.3408 20.9007 81.0115 22.0793 80.4048 23.05C80.9075 23.544 81.5228 23.934 82.2508 24.22L81.5618 25.117ZM77.2718 16.602C76.9251 16.602 76.6435 16.706 76.4268 16.914C76.2101 17.122 76.1018 17.395 76.1018 17.733C76.1018 17.9583 76.1581 18.1793 76.2708 18.396C76.3921 18.604 76.6131 18.8943 76.9338 19.267C77.4625 18.9463 77.8265 18.669 78.0258 18.435C78.2251 18.1923 78.3248 17.928 78.3248 17.642C78.3248 17.33 78.2295 17.0787 78.0388 16.888C77.8481 16.6973 77.5925 16.602 77.2718 16.602ZM76.9598 24.064C77.7311 24.064 78.4028 23.765 78.9748 23.167L76.5958 20.58C76.0758 20.9093 75.7031 21.2257 75.4778 21.529C75.2525 21.8323 75.1398 22.179 75.1398 22.569C75.1398 23.0197 75.3045 23.3837 75.6338 23.661C75.9631 23.9297 76.4051 24.064 76.9598 24.064ZM90.9262 25.104C90.0335 25.104 89.2535 24.9133 88.5862 24.532C87.9275 24.142 87.4205 23.5917 87.0652 22.881C86.7098 22.1703 86.5322 21.3297 86.5322 20.359C86.5322 19.397 86.7098 18.5607 87.0652 17.85C87.4205 17.1393 87.9275 16.5933 88.5862 16.212C89.2535 15.8307 90.0335 15.64 90.9262 15.64C91.5588 15.64 92.1438 15.7397 92.6812 15.939C93.2272 16.1297 93.6865 16.4113 94.0592 16.784L93.5912 17.772C93.1578 17.4167 92.7288 17.161 92.3042 17.005C91.8882 16.8403 91.4332 16.758 90.9392 16.758C89.9772 16.758 89.2318 17.07 88.7032 17.694C88.1832 18.318 87.9232 19.2063 87.9232 20.359C87.9232 21.5203 88.1832 22.4173 88.7032 23.05C89.2318 23.674 89.9772 23.986 90.9392 23.986C91.4332 23.986 91.8882 23.908 92.3042 23.752C92.7288 23.5873 93.1578 23.3273 93.5912 22.972L94.0592 23.96C93.6865 24.3327 93.2272 24.6187 92.6812 24.818C92.1438 25.0087 91.5588 25.104 90.9262 25.104ZM95.7569 15.432H97.0569V25H95.7569V15.432ZM101.932 25.091C101.291 25.091 100.728 24.9523 100.242 24.675C99.7572 24.3977 99.3802 24.0033 99.1115 23.492C98.8515 22.9807 98.7215 22.3827 98.7215 21.698C98.7215 21.0133 98.8515 20.4153 99.1115 19.904C99.3802 19.384 99.7572 18.9853 100.242 18.708C100.728 18.4307 101.291 18.292 101.932 18.292C102.565 18.292 103.124 18.4307 103.609 18.708C104.095 18.9853 104.467 19.384 104.727 19.904C104.996 20.4153 105.13 21.0133 105.13 21.698C105.13 22.3827 104.996 22.9807 104.727 23.492C104.467 24.0033 104.095 24.3977 103.609 24.675C103.124 24.9523 102.565 25.091 101.932 25.091ZM101.919 24.051C102.526 24.051 102.99 23.8517 103.31 23.453C103.631 23.0543 103.791 22.4693 103.791 21.698C103.791 20.944 103.627 20.3633 103.297 19.956C102.977 19.5487 102.522 19.345 101.932 19.345C101.334 19.345 100.871 19.5487 100.541 19.956C100.212 20.3633 100.047 20.944 100.047 21.698C100.047 22.4693 100.208 23.0543 100.528 23.453C100.858 23.8517 101.321 24.051 101.919 24.051ZM109.083 25.091C107.939 25.091 107.038 24.8137 106.379 24.259L106.769 23.31C107.454 23.83 108.238 24.09 109.122 24.09C109.573 24.09 109.915 24.0163 110.149 23.869C110.383 23.713 110.5 23.4963 110.5 23.219C110.5 22.985 110.418 22.803 110.253 22.673C110.097 22.5343 109.829 22.4173 109.447 22.322L108.355 22.062C107.783 21.9407 107.346 21.7283 107.042 21.425C106.748 21.113 106.6 20.7273 106.6 20.268C106.6 19.6787 106.834 19.202 107.302 18.838C107.779 18.474 108.407 18.292 109.187 18.292C109.655 18.292 110.097 18.3657 110.513 18.513C110.938 18.6603 111.298 18.8683 111.592 19.137L111.189 20.06C110.557 19.5573 109.889 19.306 109.187 19.306C108.763 19.306 108.433 19.3883 108.199 19.553C107.965 19.709 107.848 19.93 107.848 20.216C107.848 20.4413 107.922 20.6233 108.069 20.762C108.217 20.9007 108.451 21.009 108.771 21.087L109.889 21.36C110.513 21.4987 110.973 21.7197 111.267 22.023C111.571 22.3177 111.722 22.7033 111.722 23.18C111.722 23.7693 111.484 24.2373 111.007 24.584C110.539 24.922 109.898 25.091 109.083 25.091ZM118.99 21.75H114.31C114.353 23.284 115.051 24.051 116.403 24.051C117.157 24.051 117.846 23.804 118.47 23.31L118.873 24.246C118.578 24.506 118.201 24.714 117.742 24.87C117.291 25.0173 116.836 25.091 116.377 25.091C115.328 25.091 114.505 24.792 113.907 24.194C113.309 23.5873 113.01 22.7597 113.01 21.711C113.01 21.0437 113.14 20.45 113.4 19.93C113.668 19.41 114.041 19.007 114.518 18.721C114.994 18.435 115.536 18.292 116.143 18.292C117.027 18.292 117.72 18.578 118.223 19.15C118.734 19.722 118.99 20.515 118.99 21.529V21.75ZM116.169 19.267C115.675 19.267 115.272 19.4143 114.96 19.709C114.648 20.0037 114.448 20.424 114.362 20.97H117.833C117.781 20.4153 117.612 19.995 117.326 19.709C117.04 19.4143 116.654 19.267 116.169 19.267Z"
								fill="#65707E"
							/>
							<path
								d="M15.5 14C15.5 13.7239 15.7239 13.5 16 13.5H26.5858C26.7184 13.5 26.8456 13.5527 26.9393 13.6464L28.3536 15.0607C28.4473 15.1544 28.5 15.2816 28.5 15.4142V26C28.5 26.2761 28.2761 26.5 28 26.5H16C15.7239 26.5 15.5 26.2761 15.5 26V14Z"
								fill="white"
								stroke="#BEC9D7"
							/>
							<path
								d="M18 13.6364V19C18 19.5523 18.4477 20 19 20H25C25.5523 20 26 19.5523 26 19V13"
								stroke="#BEC9D7"
							/>
							<rect
								x="19.5"
								y="23.5"
								width="5"
								height="3"
								rx="0.5"
								fill="white"
								stroke="#BEC9D7"
							/>
						</svg>
					),
					onClick: this.saveAndClose
				},
				forceNextStep: {
					step: 4 + this.state.plusToStep,
					values
				},
				requestedSignatures: result
			});
			return result;
		});
	};

	requestSignatures = async values => {
		const documentReplaced = values.confirmSameData;
		delete values.confirmSameData;

		if (values.file) {
			let fileType = this.getExtension(values.file.name);
			let fileTypeProp = { type: "application/" + fileType }
			values.file = { ...values.file, ...fileTypeProp }
		}
		let formattedValues = this.agreementDataByDocumentType(stripTypenames(values));
		if (this.props.formType === "uploadToEdit") {
			const extraValues = await SaveByForm(this.state.typeSelected, formattedValues)
			this.setState({
				extraValues
			})
			formattedValues = this.agreementDataByDocumentType(stripTypenames(values));
		}
		this.setState({
			forceNextStep: {
				step: 5 + this.state.plusToStep,
				values
			},
			showButtons: false,
			footer: undefined,
			showSteps: false
		});

		const queryParams = {
			startupId: this.props.session.startup.id,
			agreement: {
				...formattedValues,
				file: this.state.file ? this.state.file : values.file,
				generatedDocuments: this.state.generatedAgreements,
				parentDocumentId: _.get(this, 'state.parentDocument.id', null),
				documentReplaced: documentReplaced
				// relatedDocuments: this.state.relatedDocuments
			},
			agreementId: _.get(this.props.params, "id", "")
		};

		return ServerConnect.graphQlMutation(requestSignatures, stripTypenames(queryParams))
			.then(result => {
				this.setState({
					fullScreenModal: this.getEndingModal()
				});
				event.emmit(Constants.EVENTS.REFRESH_ACTIVE_SUBSCRIPTION, { startupId: this.props.session.startup.id });
				return result;
			})
			.catch(err => alert(err));
	};

	closeAll() {
		this.props.goToPrevPage();
	}

	goToAgreements() {
		this.props.goToPage(Constants.PAGES.documents);
	}

	handleDisabled(values) {
		if (values.documentType === 'GRANT_AGREEMENT') {
			const parentDocument = this.state.documentList.find(dl => dl.id === _.get(values, 'terms.shareIncentivePlan.id', null));
			return _.get(parentDocument, 'status') !== 'Signed';
		}
		if (values.documentType === 'USA_BOARD_APPROVING_OPTION_GRANT') {
			const parentDocument = this.state.documentList.find(dl => dl.id === _.get(values, 'terms.equityIncentivePlan.id', null));
			return _.get(parentDocument, 'status') !== 'Signed';
		}
		if (values.documentType === 'USA_OPTION_GRANT_NOTICE') {
			const parentDocument = this.state.documentList.find(dl => dl.id === _.get(values, 'terms.boardApprovingOptionsGrant.id', null));
			return _.get(parentDocument, 'status') !== 'Signed';
		}
		return false
	}

	getEndingModal() {
		return (
			<div className={classes.AgreementModal}>
				<div className={classes.ModalCard}>
					<div className={classes.ModalLabel}>
						<div>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
									fill="white"
									stroke="#18C5A8"
								/>
								<path
									d="M15 9L11.5 14L9 11.933"
									stroke="#18C5A8"
								/>
							</svg>
						</div>
						<div>Your signature request has been sent!</div>
					</div>
					<div className={classes.ModalButtons}>
						<button
							type="submit" data-cy="submit"
							onClick={() => this.closeAll()}
							className={classes.Button}
						>
							<svg
								width="100"
								height="40"
								viewBox="0 0 100 40"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H96C97.933 0.5 99.5 2.067 99.5 4V36C99.5 37.933 97.933 39.5 96 39.5H4C2.06701 39.5 0.5 37.933 0.5 36V4Z"
									fill="white"
									stroke="#EAF1FE"
								/>
								<path
									d="M37.2048 24.104C36.3122 24.104 35.5322 23.9133 34.8648 23.532C34.2062 23.142 33.6992 22.5917 33.3438 21.881C32.9885 21.1703 32.8108 20.3297 32.8108 19.359C32.8108 18.397 32.9885 17.5607 33.3438 16.85C33.6992 16.1393 34.2062 15.5933 34.8648 15.212C35.5322 14.8307 36.3122 14.64 37.2048 14.64C37.8375 14.64 38.4225 14.7397 38.9598 14.939C39.5058 15.1297 39.9652 15.4113 40.3378 15.784L39.8698 16.772C39.4365 16.4167 39.0075 16.161 38.5828 16.005C38.1668 15.8403 37.7118 15.758 37.2178 15.758C36.2558 15.758 35.5105 16.07 34.9818 16.694C34.4618 17.318 34.2018 18.2063 34.2018 19.359C34.2018 20.5203 34.4618 21.4173 34.9818 22.05C35.5105 22.674 36.2558 22.986 37.2178 22.986C37.7118 22.986 38.1668 22.908 38.5828 22.752C39.0075 22.5873 39.4365 22.3273 39.8698 21.972L40.3378 22.96C39.9652 23.3327 39.5058 23.6187 38.9598 23.818C38.4225 24.0087 37.8375 24.104 37.2048 24.104ZM42.0356 14.432H43.3356V24H42.0356V14.432ZM48.2112 24.091C47.5698 24.091 47.0065 23.9523 46.5212 23.675C46.0358 23.3977 45.6588 23.0033 45.3902 22.492C45.1302 21.9807 45.0002 21.3827 45.0002 20.698C45.0002 20.0133 45.1302 19.4153 45.3902 18.904C45.6588 18.384 46.0358 17.9853 46.5212 17.708C47.0065 17.4307 47.5698 17.292 48.2112 17.292C48.8438 17.292 49.4028 17.4307 49.8882 17.708C50.3735 17.9853 50.7462 18.384 51.0062 18.904C51.2748 19.4153 51.4092 20.0133 51.4092 20.698C51.4092 21.3827 51.2748 21.9807 51.0062 22.492C50.7462 23.0033 50.3735 23.3977 49.8882 23.675C49.4028 23.9523 48.8438 24.091 48.2112 24.091ZM48.1982 23.051C48.8048 23.051 49.2685 22.8517 49.5892 22.453C49.9098 22.0543 50.0702 21.4693 50.0702 20.698C50.0702 19.944 49.9055 19.3633 49.5762 18.956C49.2555 18.5487 48.8005 18.345 48.2112 18.345C47.6132 18.345 47.1495 18.5487 46.8202 18.956C46.4908 19.3633 46.3262 19.944 46.3262 20.698C46.3262 21.4693 46.4865 22.0543 46.8072 22.453C47.1365 22.8517 47.6002 23.051 48.1982 23.051ZM55.3619 24.091C54.2179 24.091 53.3165 23.8137 52.6579 23.259L53.0479 22.31C53.7325 22.83 54.5169 23.09 55.4009 23.09C55.8515 23.09 56.1939 23.0163 56.4279 22.869C56.6619 22.713 56.7789 22.4963 56.7789 22.219C56.7789 21.985 56.6965 21.803 56.5319 21.673C56.3759 21.5343 56.1072 21.4173 55.7259 21.322L54.6339 21.062C54.0619 20.9407 53.6242 20.7283 53.3209 20.425C53.0262 20.113 52.8789 19.7273 52.8789 19.268C52.8789 18.6787 53.1129 18.202 53.5809 17.838C54.0575 17.474 54.6859 17.292 55.4659 17.292C55.9339 17.292 56.3759 17.3657 56.7919 17.513C57.2165 17.6603 57.5762 17.8683 57.8709 18.137L57.4679 19.06C56.8352 18.5573 56.1679 18.306 55.4659 18.306C55.0412 18.306 54.7119 18.3883 54.4779 18.553C54.2439 18.709 54.1269 18.93 54.1269 19.216C54.1269 19.4413 54.2005 19.6233 54.3479 19.762C54.4952 19.9007 54.7292 20.009 55.0499 20.087L56.1679 20.36C56.7919 20.4987 57.2512 20.7197 57.5459 21.023C57.8492 21.3177 58.0009 21.7033 58.0009 22.18C58.0009 22.7693 57.7625 23.2373 57.2859 23.584C56.8179 23.922 56.1765 24.091 55.3619 24.091ZM65.2685 20.75H60.5885C60.6318 22.284 61.3295 23.051 62.6815 23.051C63.4355 23.051 64.1245 22.804 64.7485 22.31L65.1515 23.246C64.8568 23.506 64.4798 23.714 64.0205 23.87C63.5698 24.0173 63.1148 24.091 62.6555 24.091C61.6068 24.091 60.7835 23.792 60.1855 23.194C59.5875 22.5873 59.2885 21.7597 59.2885 20.711C59.2885 20.0437 59.4185 19.45 59.6785 18.93C59.9472 18.41 60.3198 18.007 60.7965 17.721C61.2732 17.435 61.8148 17.292 62.4215 17.292C63.3055 17.292 63.9988 17.578 64.5015 18.15C65.0128 18.722 65.2685 19.515 65.2685 20.529V20.75ZM62.4475 18.267C61.9535 18.267 61.5505 18.4143 61.2385 18.709C60.9265 19.0037 60.7272 19.424 60.6405 19.97H64.1115C64.0595 19.4153 63.8905 18.995 63.6045 18.709C63.3185 18.4143 62.9328 18.267 62.4475 18.267Z"
									fill="#65707E"
								/>
							</svg>
						</button>
						<button
							type="submit" data-cy="submit"
							onClick={() => this.goToAgreements()}
							className={classes.GoToDocumentsButton}
						>
							Go to Documents
						</button>
					</div>
				</div>
			</div>
		);
	}

	handleDownloadAsDoc(file) {
		let url = ServerConnect.getPublicUrlFile(file.id);
		ServerConnect.downloadFileAsDoc(url, file.name);
	}

	isGetSignatures() {
		const type = _.find(this.state.documentsTypes, type => type.code === this.state.typeSelected)
		const isAllowedGetSignatures = helper.getValueFromKey(type.allowedActions, 'getSignature', true)
		if (!_.isEmpty(type.relatedDocuments)) {
			const relatedDocumentIsAllowedGetSignatures = _.some(type.relatedDocuments, relatedDocument => {
				const type = _.find(this.state.documentsTypes, type => type.code === relatedDocument)
				return helper.getValueFromKey(type.allowedActions, 'getSignature', true)
			})
			return isAllowedGetSignatures || relatedDocumentIsAllowedGetSignatures
		}
		return isAllowedGetSignatures
	}

	getStep3Footer = (result, values) => {
		return (
			<div className={classes.FlexFooter}>
				<div className={classes.TitleAgreement}>

				</div>
				<div className={classes.ButtonsAgreement}>
					<button
						type="submit" data-cy="submit"
						onClick={async () => {
							this.edit(0, values)
							this.setState({
								firstLoading: true,
								showLoading: true,
							})
							this.loadStakeholders(this.props)
							this.loadGroupCompanies(this.props)
						}}
						className={classes.Button2}
					>
						<svg
							width="80"
							height="40"
							viewBox="0 0 80 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H76C77.933 0.5 79.5 2.067 79.5 4V36C79.5 37.933 77.933 39.5 76 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z"
								fill={"white"}
								stroke="#EAF1FE"
							/>
							<path
								d="M40.079 15.744H46.085V16.836H41.405V19.748H45.825V20.84H41.405V23.908H46.085V25H40.079V15.744ZM53.7657 15.432V25H52.4657V23.882C52.275 24.272 51.989 24.571 51.6077 24.779C51.235 24.987 50.7973 25.091 50.2947 25.091C49.7313 25.091 49.2287 24.948 48.7867 24.662C48.3447 24.376 47.998 23.9773 47.7467 23.466C47.504 22.946 47.3827 22.348 47.3827 21.672C47.3827 20.996 47.504 20.4023 47.7467 19.891C47.9893 19.3797 48.3273 18.9853 48.7607 18.708C49.2027 18.4307 49.714 18.292 50.2947 18.292C50.7887 18.292 51.222 18.396 51.5947 18.604C51.976 18.812 52.262 19.1067 52.4527 19.488V15.432H53.7657ZM50.5937 24.051C51.1917 24.051 51.651 23.8473 51.9717 23.44C52.301 23.024 52.4657 22.4433 52.4657 21.698C52.4657 20.9527 52.301 20.3763 51.9717 19.969C51.651 19.553 51.196 19.345 50.6067 19.345C50.0087 19.345 49.5407 19.5487 49.2027 19.956C48.8733 20.3633 48.7087 20.9353 48.7087 21.672C48.7087 22.4173 48.8733 23.0023 49.2027 23.427C49.5407 23.843 50.0043 24.051 50.5937 24.051ZM55.8245 18.448H57.1245V25H55.8245V18.448ZM57.2285 15.588V16.966H55.7075V15.588H57.2285ZM60.8821 19.462V22.751C60.8821 23.2017 60.9775 23.5223 61.1681 23.713C61.3675 23.895 61.6405 23.986 61.9871 23.986C62.2125 23.986 62.4421 23.9513 62.6761 23.882V24.948C62.3901 25.0433 62.0651 25.091 61.7011 25.091C61.0251 25.091 60.5008 24.9003 60.1281 24.519C59.7555 24.1377 59.5691 23.583 59.5691 22.855V19.462H58.2951V18.448H59.5691V16.81L60.8821 16.355V18.448H62.6891V19.462H60.8821Z"
								fill="#65707E"
							/>
							<path
								d="M27.565 18.7829V25.7828C27.565 26.4551 27.0199 27.0001 26.3476 27.0001H17.2174C16.545 27.0001 16 26.4551 16 25.7828V15.4351C16 14.7628 16.545 14.2178 17.2174 14.2178H25.1302"
								stroke="#BEC9D7"
							/>
							<path
								d="M21.3398 21.6604L22.2005 19.5081L27.7961 13.9131L29.0872 15.2041L23.4921 20.7997L21.3398 21.6604Z"
								stroke="#BEC9D7"
							/>
							<path
								d="M29.0879 15.2043L27.7969 13.9133L28.4421 13.2675C28.7988 12.9108 29.377 12.9108 29.7337 13.2675C30.0904 13.6242 30.0904 14.2025 29.7337 14.5591L29.0879 15.2043Z"
								stroke="#BEC9D7"
							/>
						</svg>
					</button>
					<button
						type="submit" data-cy="submit"
						onClick={() => this.saveAndClose(values)}
						className={classes.Button2}
					>
						<svg
							width="135"
							height="40"
							viewBox="0 0 135 40"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H131C132.933 0.5 134.5 2.067 134.5 4V36C134.5 37.933 132.933 39.5 131 39.5H4C2.06701 39.5 0.5 37.933 0.5 36V4Z"
								fill={this.isGetSignatures() ? "white" : "#2C74FF"}
								stroke={this.isGetSignatures() ? "#EAF1FE" : null}
							/>
							<path
								d="M43.108 25.104C42.3887 25.104 41.73 25.0087 41.132 24.818C40.5427 24.6273 40.0313 24.3413 39.598 23.96L40.079 22.972C40.5297 23.336 40.9977 23.6003 41.483 23.765C41.9683 23.9297 42.5143 24.012 43.121 24.012C43.8143 24.012 44.3517 23.882 44.733 23.622C45.1143 23.362 45.305 22.9937 45.305 22.517C45.305 22.1183 45.1273 21.8193 44.772 21.62C44.4167 21.412 43.8533 21.2213 43.082 21.048C42.3453 20.892 41.743 20.7143 41.275 20.515C40.807 20.307 40.4387 20.034 40.17 19.696C39.9013 19.3493 39.767 18.9073 39.767 18.37C39.767 17.8327 39.91 17.3603 40.196 16.953C40.482 16.537 40.885 16.2163 41.405 15.991C41.9337 15.757 42.5403 15.64 43.225 15.64C43.875 15.64 44.4817 15.7397 45.045 15.939C45.617 16.1383 46.0937 16.42 46.475 16.784L45.994 17.772C45.5693 17.4167 45.1317 17.1567 44.681 16.992C44.2303 16.8187 43.7493 16.732 43.238 16.732C42.5707 16.732 42.0463 16.875 41.665 17.161C41.2837 17.4383 41.093 17.8197 41.093 18.305C41.093 18.721 41.2577 19.0373 41.587 19.254C41.925 19.4707 42.4623 19.6657 43.199 19.839C43.9703 20.0123 44.5943 20.1943 45.071 20.385C45.5477 20.5757 45.929 20.8357 46.215 21.165C46.501 21.4943 46.644 21.919 46.644 22.439C46.644 22.9763 46.501 23.4443 46.215 23.843C45.929 24.2417 45.5173 24.5537 44.98 24.779C44.4513 24.9957 43.8273 25.104 43.108 25.104ZM54.3116 18.448V25H53.0116V23.882C52.8209 24.272 52.5349 24.571 52.1536 24.779C51.7809 24.987 51.3432 25.091 50.8406 25.091C50.2599 25.091 49.7486 24.9523 49.3066 24.675C48.8732 24.3977 48.5352 24.0077 48.2926 23.505C48.0499 22.9937 47.9286 22.4 47.9286 21.724C47.9286 21.048 48.0499 20.45 48.2926 19.93C48.5439 19.41 48.8906 19.007 49.3326 18.721C49.7746 18.435 50.2772 18.292 50.8406 18.292C51.3432 18.292 51.7809 18.4003 52.1536 18.617C52.5262 18.825 52.8122 19.124 53.0116 19.514V18.448H54.3116ZM51.1526 24.051C51.7419 24.051 52.1969 23.8473 52.5176 23.44C52.8469 23.024 53.0116 22.4433 53.0116 21.698C53.0116 20.944 52.8469 20.3633 52.5176 19.956C52.1969 19.5487 51.7376 19.345 51.1396 19.345C50.5502 19.345 50.0866 19.5573 49.7486 19.982C49.4192 20.398 49.2546 20.9787 49.2546 21.724C49.2546 22.4607 49.4192 23.0327 49.7486 23.44C50.0866 23.8473 50.5546 24.051 51.1526 24.051ZM62.3244 18.461L59.4774 25H58.2944L55.4734 18.461H56.8644L58.9184 23.518L61.0114 18.461H62.3244ZM68.9713 21.75H64.2913C64.3346 23.284 65.0323 24.051 66.3843 24.051C67.1383 24.051 67.8273 23.804 68.4513 23.31L68.8543 24.246C68.5596 24.506 68.1826 24.714 67.7233 24.87C67.2726 25.0173 66.8176 25.091 66.3583 25.091C65.3096 25.091 64.4863 24.792 63.8883 24.194C63.2903 23.5873 62.9913 22.7597 62.9913 21.711C62.9913 21.0437 63.1213 20.45 63.3813 19.93C63.65 19.41 64.0226 19.007 64.4993 18.721C64.976 18.435 65.5176 18.292 66.1243 18.292C67.0083 18.292 67.7016 18.578 68.2043 19.15C68.7156 19.722 68.9713 20.515 68.9713 21.529V21.75ZM66.1503 19.267C65.6563 19.267 65.2533 19.4143 64.9413 19.709C64.6293 20.0037 64.43 20.424 64.3433 20.97H67.8143C67.7623 20.4153 67.5933 19.995 67.3073 19.709C67.0213 19.4143 66.6356 19.267 66.1503 19.267ZM81.5618 25.117C80.8511 24.831 80.2315 24.4367 79.7028 23.934C79.3301 24.3067 78.9055 24.5927 78.4288 24.792C77.9608 24.9913 77.4581 25.091 76.9208 25.091C76.3141 25.091 75.7768 24.9913 75.3088 24.792C74.8495 24.584 74.4898 24.2937 74.2298 23.921C73.9785 23.5483 73.8528 23.1193 73.8528 22.634C73.8528 22.0707 74.0131 21.568 74.3338 21.126C74.6631 20.684 75.1918 20.255 75.9198 19.839C75.5385 19.4143 75.2655 19.046 75.1008 18.734C74.9448 18.4133 74.8668 18.084 74.8668 17.746C74.8668 17.122 75.0878 16.6193 75.5298 16.238C75.9718 15.848 76.5481 15.653 77.2588 15.653C77.9261 15.653 78.4548 15.8263 78.8448 16.173C79.2435 16.5197 79.4428 16.9877 79.4428 17.577C79.4428 18.045 79.3041 18.461 79.0268 18.825C78.7495 19.189 78.2771 19.579 77.6098 19.995L79.6378 22.205C80.0191 21.451 80.2271 20.554 80.2618 19.514H81.3928C81.3408 20.9007 81.0115 22.0793 80.4048 23.05C80.9075 23.544 81.5228 23.934 82.2508 24.22L81.5618 25.117ZM77.2718 16.602C76.9251 16.602 76.6435 16.706 76.4268 16.914C76.2101 17.122 76.1018 17.395 76.1018 17.733C76.1018 17.9583 76.1581 18.1793 76.2708 18.396C76.3921 18.604 76.6131 18.8943 76.9338 19.267C77.4625 18.9463 77.8265 18.669 78.0258 18.435C78.2251 18.1923 78.3248 17.928 78.3248 17.642C78.3248 17.33 78.2295 17.0787 78.0388 16.888C77.8481 16.6973 77.5925 16.602 77.2718 16.602ZM76.9598 24.064C77.7311 24.064 78.4028 23.765 78.9748 23.167L76.5958 20.58C76.0758 20.9093 75.7031 21.2257 75.4778 21.529C75.2525 21.8323 75.1398 22.179 75.1398 22.569C75.1398 23.0197 75.3045 23.3837 75.6338 23.661C75.9631 23.9297 76.4051 24.064 76.9598 24.064ZM90.9262 25.104C90.0335 25.104 89.2535 24.9133 88.5862 24.532C87.9275 24.142 87.4205 23.5917 87.0652 22.881C86.7098 22.1703 86.5322 21.3297 86.5322 20.359C86.5322 19.397 86.7098 18.5607 87.0652 17.85C87.4205 17.1393 87.9275 16.5933 88.5862 16.212C89.2535 15.8307 90.0335 15.64 90.9262 15.64C91.5588 15.64 92.1438 15.7397 92.6812 15.939C93.2272 16.1297 93.6865 16.4113 94.0592 16.784L93.5912 17.772C93.1578 17.4167 92.7288 17.161 92.3042 17.005C91.8882 16.8403 91.4332 16.758 90.9392 16.758C89.9772 16.758 89.2318 17.07 88.7032 17.694C88.1832 18.318 87.9232 19.2063 87.9232 20.359C87.9232 21.5203 88.1832 22.4173 88.7032 23.05C89.2318 23.674 89.9772 23.986 90.9392 23.986C91.4332 23.986 91.8882 23.908 92.3042 23.752C92.7288 23.5873 93.1578 23.3273 93.5912 22.972L94.0592 23.96C93.6865 24.3327 93.2272 24.6187 92.6812 24.818C92.1438 25.0087 91.5588 25.104 90.9262 25.104ZM95.7569 15.432H97.0569V25H95.7569V15.432ZM101.932 25.091C101.291 25.091 100.728 24.9523 100.242 24.675C99.7572 24.3977 99.3802 24.0033 99.1115 23.492C98.8515 22.9807 98.7215 22.3827 98.7215 21.698C98.7215 21.0133 98.8515 20.4153 99.1115 19.904C99.3802 19.384 99.7572 18.9853 100.242 18.708C100.728 18.4307 101.291 18.292 101.932 18.292C102.565 18.292 103.124 18.4307 103.609 18.708C104.095 18.9853 104.467 19.384 104.727 19.904C104.996 20.4153 105.13 21.0133 105.13 21.698C105.13 22.3827 104.996 22.9807 104.727 23.492C104.467 24.0033 104.095 24.3977 103.609 24.675C103.124 24.9523 102.565 25.091 101.932 25.091ZM101.919 24.051C102.526 24.051 102.99 23.8517 103.31 23.453C103.631 23.0543 103.791 22.4693 103.791 21.698C103.791 20.944 103.627 20.3633 103.297 19.956C102.977 19.5487 102.522 19.345 101.932 19.345C101.334 19.345 100.871 19.5487 100.541 19.956C100.212 20.3633 100.047 20.944 100.047 21.698C100.047 22.4693 100.208 23.0543 100.528 23.453C100.858 23.8517 101.321 24.051 101.919 24.051ZM109.083 25.091C107.939 25.091 107.038 24.8137 106.379 24.259L106.769 23.31C107.454 23.83 108.238 24.09 109.122 24.09C109.573 24.09 109.915 24.0163 110.149 23.869C110.383 23.713 110.5 23.4963 110.5 23.219C110.5 22.985 110.418 22.803 110.253 22.673C110.097 22.5343 109.829 22.4173 109.447 22.322L108.355 22.062C107.783 21.9407 107.346 21.7283 107.042 21.425C106.748 21.113 106.6 20.7273 106.6 20.268C106.6 19.6787 106.834 19.202 107.302 18.838C107.779 18.474 108.407 18.292 109.187 18.292C109.655 18.292 110.097 18.3657 110.513 18.513C110.938 18.6603 111.298 18.8683 111.592 19.137L111.189 20.06C110.557 19.5573 109.889 19.306 109.187 19.306C108.763 19.306 108.433 19.3883 108.199 19.553C107.965 19.709 107.848 19.93 107.848 20.216C107.848 20.4413 107.922 20.6233 108.069 20.762C108.217 20.9007 108.451 21.009 108.771 21.087L109.889 21.36C110.513 21.4987 110.973 21.7197 111.267 22.023C111.571 22.3177 111.722 22.7033 111.722 23.18C111.722 23.7693 111.484 24.2373 111.007 24.584C110.539 24.922 109.898 25.091 109.083 25.091ZM118.99 21.75H114.31C114.353 23.284 115.051 24.051 116.403 24.051C117.157 24.051 117.846 23.804 118.47 23.31L118.873 24.246C118.578 24.506 118.201 24.714 117.742 24.87C117.291 25.0173 116.836 25.091 116.377 25.091C115.328 25.091 114.505 24.792 113.907 24.194C113.309 23.5873 113.01 22.7597 113.01 21.711C113.01 21.0437 113.14 20.45 113.4 19.93C113.668 19.41 114.041 19.007 114.518 18.721C114.994 18.435 115.536 18.292 116.143 18.292C117.027 18.292 117.72 18.578 118.223 19.15C118.734 19.722 118.99 20.515 118.99 21.529V21.75ZM116.169 19.267C115.675 19.267 115.272 19.4143 114.96 19.709C114.648 20.0037 114.448 20.424 114.362 20.97H117.833C117.781 20.4153 117.612 19.995 117.326 19.709C117.04 19.4143 116.654 19.267 116.169 19.267Z"
								fill={this.isGetSignatures() ? "#65707E" : 'white'}
							/>
							<path
								d="M15.5 14C15.5 13.7239 15.7239 13.5 16 13.5H26.5858C26.7184 13.5 26.8456 13.5527 26.9393 13.6464L28.3536 15.0607C28.4473 15.1544 28.5 15.2816 28.5 15.4142V26C28.5 26.2761 28.2761 26.5 28 26.5H16C15.7239 26.5 15.5 26.2761 15.5 26V14Z"
								fill="white"
								stroke="#BEC9D7"
							/>
							<path
								d="M18 13.6364V19C18 19.5523 18.4477 20 19 20H25C25.5523 20 26 19.5523 26 19V13"
								stroke={this.isGetSignatures() ? "#BEC9D7" : "#2C74FF"}
							/>
							<rect
								x="19.5"
								y="23.5"
								width="5"
								height="3"
								rx="0.5"
								fill="white"
								stroke={this.isGetSignatures() ? "#BEC9D7" : "#2C74FF"}
							/>
						</svg>
					</button>
					{this.isGetSignatures() ?
						<button
							type="submit" data-cy="submit" s
							onClick={() => this.getSignatures(values)}
							className={classes.Button2}
							disabled={this.handleDisabled(values)}
						>
							<svg
								width="130"
								height="40"
								viewBox="0 0 130 40"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M0 4C0 1.79086 1.79086 0 4 0H126C128.209 0 130 1.79086 130 4V36C130 38.2091 128.209 40 126 40H4C1.79086 40 0 38.2091 0 36V4Z"
									fill="#2C74FF"
								/>
								<path
									d="M26.9176 19.086V23.454C26.5276 23.6533 26.0336 23.8137 25.4356 23.935C24.8462 24.0477 24.2439 24.104 23.6286 24.104C22.6926 24.104 21.8822 23.9177 21.1976 23.545C20.5129 23.1637 19.9886 22.6177 19.6246 21.907C19.2692 21.1963 19.0916 20.347 19.0916 19.359C19.0916 18.3883 19.2692 17.5477 19.6246 16.837C19.9886 16.1263 20.5042 15.5847 21.1716 15.212C21.8476 14.8307 22.6406 14.64 23.5506 14.64C24.2006 14.64 24.7986 14.7397 25.3446 14.939C25.8992 15.1297 26.3716 15.407 26.7616 15.771L26.2806 16.772C25.8386 16.408 25.4052 16.148 24.9806 15.992C24.5559 15.836 24.0836 15.758 23.5636 15.758C22.5582 15.758 21.7912 16.0657 21.2626 16.681C20.7426 17.2963 20.4826 18.189 20.4826 19.359C20.4826 20.5637 20.7512 21.478 21.2886 22.102C21.8259 22.7173 22.6189 23.025 23.6676 23.025C24.3696 23.025 25.0456 22.921 25.6956 22.713V20.113H23.5376V19.086H26.9176ZM34.5791 20.75H29.8991C29.9425 22.284 30.6401 23.051 31.9921 23.051C32.7461 23.051 33.4351 22.804 34.0591 22.31L34.4621 23.246C34.1675 23.506 33.7905 23.714 33.3311 23.87C32.8805 24.0173 32.4255 24.091 31.9661 24.091C30.9175 24.091 30.0941 23.792 29.4961 23.194C28.8981 22.5873 28.5991 21.7597 28.5991 20.711C28.5991 20.0437 28.7291 19.45 28.9891 18.93C29.2578 18.41 29.6305 18.007 30.1071 17.721C30.5838 17.435 31.1255 17.292 31.7321 17.292C32.6161 17.292 33.3095 17.578 33.8121 18.15C34.3235 18.722 34.5791 19.515 34.5791 20.529V20.75ZM31.7581 18.267C31.2641 18.267 30.8611 18.4143 30.5491 18.709C30.2371 19.0037 30.0378 19.424 29.9511 19.97H33.4221C33.3701 19.4153 33.2011 18.995 32.9151 18.709C32.6291 18.4143 32.2435 18.267 31.7581 18.267ZM37.8553 18.462V21.751C37.8553 22.2017 37.9507 22.5223 38.1413 22.713C38.3407 22.895 38.6137 22.986 38.9603 22.986C39.1857 22.986 39.4153 22.9513 39.6493 22.882V23.948C39.3633 24.0433 39.0383 24.091 38.6743 24.091C37.9983 24.091 37.474 23.9003 37.1013 23.519C36.7287 23.1377 36.5423 22.583 36.5423 21.855V18.462H35.2683V17.448H36.5423V15.81L37.8553 15.355V17.448H39.6623V18.462H37.8553ZM47.7468 24.104C47.0275 24.104 46.3688 24.0087 45.7708 23.818C45.1815 23.6273 44.6701 23.3413 44.2368 22.96L44.7178 21.972C45.1685 22.336 45.6365 22.6003 46.1218 22.765C46.6071 22.9297 47.1531 23.012 47.7598 23.012C48.4531 23.012 48.9905 22.882 49.3718 22.622C49.7531 22.362 49.9438 21.9937 49.9438 21.517C49.9438 21.1183 49.7661 20.8193 49.4108 20.62C49.0555 20.412 48.4921 20.2213 47.7208 20.048C46.9841 19.892 46.3818 19.7143 45.9138 19.515C45.4458 19.307 45.0775 19.034 44.8088 18.696C44.5401 18.3493 44.4058 17.9073 44.4058 17.37C44.4058 16.8327 44.5488 16.3603 44.8348 15.953C45.1208 15.537 45.5238 15.2163 46.0438 14.991C46.5725 14.757 47.1791 14.64 47.8638 14.64C48.5138 14.64 49.1205 14.7397 49.6838 14.939C50.2558 15.1383 50.7325 15.42 51.1138 15.784L50.6328 16.772C50.2081 16.4167 49.7705 16.1567 49.3198 15.992C48.8691 15.8187 48.3881 15.732 47.8768 15.732C47.2095 15.732 46.6851 15.875 46.3038 16.161C45.9225 16.4383 45.7318 16.8197 45.7318 17.305C45.7318 17.721 45.8965 18.0373 46.2258 18.254C46.5638 18.4707 47.1011 18.6657 47.8378 18.839C48.6091 19.0123 49.2331 19.1943 49.7098 19.385C50.1865 19.5757 50.5678 19.8357 50.8538 20.165C51.1398 20.4943 51.2828 20.919 51.2828 21.439C51.2828 21.9763 51.1398 22.4443 50.8538 22.843C50.5678 23.2417 50.1561 23.5537 49.6188 23.779C49.0901 23.9957 48.4661 24.104 47.7468 24.104ZM52.9574 17.448H54.2574V24H52.9574V17.448ZM54.3614 14.588V15.966H52.8404V14.588H54.3614ZM62.357 17.448V23.883C62.357 24.8797 62.0926 25.6293 61.564 26.132C61.044 26.6433 60.2683 26.899 59.237 26.899C58.2403 26.899 57.3693 26.6823 56.624 26.249L56.845 25.222C57.2523 25.4387 57.6423 25.599 58.015 25.703C58.3963 25.807 58.7993 25.859 59.224 25.859C60.446 25.859 61.057 25.235 61.057 23.987V22.57C60.8576 22.9513 60.5673 23.2547 60.186 23.48C59.8046 23.6967 59.3626 23.805 58.86 23.805C58.288 23.805 57.7766 23.6707 57.326 23.402C56.884 23.1333 56.5373 22.752 56.286 22.258C56.0433 21.764 55.922 21.1963 55.922 20.555C55.922 19.9137 56.0433 19.346 56.286 18.852C56.5373 18.358 56.884 17.9767 57.326 17.708C57.7766 17.4307 58.288 17.292 58.86 17.292C59.3626 17.292 59.8046 17.4003 60.186 17.617C60.5673 17.825 60.8576 18.124 61.057 18.514V17.448H62.357ZM59.159 22.752C59.7483 22.752 60.212 22.557 60.55 22.167C60.888 21.777 61.057 21.2397 61.057 20.555C61.057 19.8703 60.888 19.333 60.55 18.943C60.2206 18.5443 59.757 18.345 59.159 18.345C58.5696 18.345 58.1016 18.5443 57.755 18.943C57.417 19.333 57.248 19.8703 57.248 20.555C57.248 21.231 57.417 21.7683 57.755 22.167C58.1016 22.557 58.5696 22.752 59.159 22.752ZM67.8986 17.292C69.4673 17.292 70.2516 18.1673 70.2516 19.918V24H68.9386V19.996C68.9386 19.424 68.826 19.008 68.6006 18.748C68.384 18.488 68.033 18.358 67.5476 18.358C66.993 18.358 66.5466 18.5313 66.2086 18.878C65.8793 19.2247 65.7146 19.6883 65.7146 20.269V24H64.4146V19.294C64.4146 18.6093 64.38 17.994 64.3106 17.448H65.5326L65.6496 18.579C65.8576 18.163 66.1566 17.8467 66.5466 17.63C66.9453 17.4047 67.396 17.292 67.8986 17.292ZM78.2437 17.448V24H76.9437V22.882C76.753 23.272 76.467 23.571 76.0857 23.779C75.713 23.987 75.2754 24.091 74.7727 24.091C74.192 24.091 73.6807 23.9523 73.2387 23.675C72.8054 23.3977 72.4674 23.0077 72.2247 22.505C71.982 21.9937 71.8607 21.4 71.8607 20.724C71.8607 20.048 71.982 19.45 72.2247 18.93C72.476 18.41 72.8227 18.007 73.2647 17.721C73.7067 17.435 74.2094 17.292 74.7727 17.292C75.2754 17.292 75.713 17.4003 76.0857 17.617C76.4584 17.825 76.7444 18.124 76.9437 18.514V17.448H78.2437ZM75.0847 23.051C75.674 23.051 76.129 22.8473 76.4497 22.44C76.779 22.024 76.9437 21.4433 76.9437 20.698C76.9437 19.944 76.779 19.3633 76.4497 18.956C76.129 18.5487 75.6697 18.345 75.0717 18.345C74.4824 18.345 74.0187 18.5573 73.6807 18.982C73.3514 19.398 73.1867 19.9787 73.1867 20.724C73.1867 21.4607 73.3514 22.0327 73.6807 22.44C74.0187 22.8473 74.4867 23.051 75.0847 23.051ZM82.0056 18.462V21.751C82.0056 22.2017 82.1009 22.5223 82.2916 22.713C82.4909 22.895 82.7639 22.986 83.1106 22.986C83.3359 22.986 83.5656 22.9513 83.7996 22.882V23.948C83.5136 24.0433 83.1886 24.091 82.8246 24.091C82.1486 24.091 81.6242 23.9003 81.2516 23.519C80.8789 23.1377 80.6926 22.583 80.6926 21.855V18.462H79.4186V17.448H80.6926V15.81L82.0056 15.355V17.448H83.8126V18.462H82.0056ZM90.8492 17.448V24H89.5752V22.908C89.3672 23.2893 89.0812 23.584 88.7172 23.792C88.3532 23.9913 87.9416 24.091 87.4822 24.091C85.9049 24.091 85.1162 23.2157 85.1162 21.465V17.448H86.4162V21.452C86.4162 21.9893 86.5246 22.388 86.7412 22.648C86.9666 22.8993 87.3046 23.025 87.7552 23.025C88.2926 23.025 88.7216 22.8517 89.0422 22.505C89.3716 22.1583 89.5362 21.699 89.5362 21.127V17.448H90.8492ZM96.1654 17.292C96.3647 17.292 96.5727 17.3223 96.7894 17.383L96.7634 18.579C96.5294 18.4923 96.2737 18.449 95.9964 18.449C95.3984 18.449 94.9477 18.631 94.6444 18.995C94.3497 19.3503 94.2024 19.801 94.2024 20.347V24H92.9024V19.294C92.9024 18.6093 92.8677 17.994 92.7984 17.448H94.0204L94.1374 18.631C94.3107 18.1977 94.5794 17.8683 94.9434 17.643C95.3074 17.409 95.7147 17.292 96.1654 17.292ZM103.383 20.75H98.7031C98.7465 22.284 99.4441 23.051 100.796 23.051C101.55 23.051 102.239 22.804 102.863 22.31L103.266 23.246C102.971 23.506 102.594 23.714 102.135 23.87C101.684 24.0173 101.229 24.091 100.77 24.091C99.7215 24.091 98.8981 23.792 98.3001 23.194C97.7021 22.5873 97.4031 21.7597 97.4031 20.711C97.4031 20.0437 97.5331 19.45 97.7931 18.93C98.0618 18.41 98.4345 18.007 98.9111 17.721C99.3878 17.435 99.9295 17.292 100.536 17.292C101.42 17.292 102.113 17.578 102.616 18.15C103.127 18.722 103.383 19.515 103.383 20.529V20.75ZM100.562 18.267C100.068 18.267 99.6651 18.4143 99.3531 18.709C99.0411 19.0037 98.8418 19.424 98.7551 19.97H102.226C102.174 19.4153 102.005 18.995 101.719 18.709C101.433 18.4143 101.047 18.267 100.562 18.267ZM107.308 24.091C106.164 24.091 105.262 23.8137 104.604 23.259L104.994 22.31C105.678 22.83 106.463 23.09 107.347 23.09C107.797 23.09 108.14 23.0163 108.374 22.869C108.608 22.713 108.725 22.4963 108.725 22.219C108.725 21.985 108.642 21.803 108.478 21.673C108.322 21.5343 108.053 21.4173 107.672 21.322L106.58 21.062C106.008 20.9407 105.57 20.7283 105.267 20.425C104.972 20.113 104.825 19.7273 104.825 19.268C104.825 18.6787 105.059 18.202 105.527 17.838C106.003 17.474 106.632 17.292 107.412 17.292C107.88 17.292 108.322 17.3657 108.738 17.513C109.162 17.6603 109.522 17.8683 109.817 18.137L109.414 19.06C108.781 18.5573 108.114 18.306 107.412 18.306C106.987 18.306 106.658 18.3883 106.424 18.553C106.19 18.709 106.073 18.93 106.073 19.216C106.073 19.4413 106.146 19.6233 106.294 19.762C106.441 19.9007 106.675 20.009 106.996 20.087L108.114 20.36C108.738 20.4987 109.197 20.7197 109.492 21.023C109.795 21.3177 109.947 21.7033 109.947 22.18C109.947 22.7693 109.708 23.2373 109.232 23.584C108.764 23.922 108.122 24.091 107.308 24.091Z"
									fill="white"
								/>
							</svg>
						</button> : null
					}
				</div>
			</div>
		);
	};

	submitForm(values, actions) {
	}

	aumentCounter = () => {
		this.setState(prevState => ({
			counter: (prevState.counter += 1)
		}));
	};

	componentWillUpdate(nextProps, nextState, nextContext) {
		if (!(nextState.loadingStakeholders || nextState.loadingGroupCompanies) && nextState.firstLoading) {
			this.setState({
				showLoading: false,
				firstLoading: false
			})
		}
	}

	loadStakeholders = (props) => {

		this.setState({
			loadingStakeholders: true
		})

		const stakeholderList = `
		${RoleFields}
		${NoticesFragment}
		${AuthorizedSignatoryFragment}
		{
			stakeholderList(startupId: "{{startupId}}") {
				email
				title
				passportNumber
				phoneNumber
				registeredNumber
				nationality {name code}
				jurisdiction
				type
				id
				startupPosition {
					department{id}
					position {
						id
						code
						name
						isDefault
						responsibilities {
							id
							code
							name
							text
							isDefault
						}
					}
				}
				isAnEntity
				address {
					city
					state
					country {name code}
					zipCode 
					street
				}
				fullName
				roles { ...RoleFields }
				isFounder
				authorizedSignatory {...AuthorizedSignatoryFragment}
				recipientNotice {...NoticesFragment}
            }
        }`;

		const queryParams = { startupId: props.session.startup.id };
		const stakeholdersQuery = Mustache.render(stakeholderList, queryParams);
		ServerConnect.graphQlQuery(stakeholdersQuery).then(result2 => {
			if (result2 && result2.stakeholderList) {
				const stakeholderList = this.filterStakeholdersByDocumentType(result2.stakeholderList, props.params.docType);
				this.setState({
					stakeholderList: stakeholderList,
					stakeholders: this.mapStakeholders(stakeholderList),
					loadingStakeholders: false
				});
			}
		});
	};

	filterStakeholdersByDocumentType = (stakeholderList, docType) => {
		if (docType === 'ADVISOR_AGREEMENT'
			|| docType === 'EMPLOYMENT_AGREEMENT_ADGM'
			|| docType === 'EMPLOYMENT_AGREEMENT_DIFC'
			|| docType === 'EMPLOYMENT_AGREEMENT_UK'
			|| docType === 'FOUNDER_SERVICES_AGREEMENT'
			|| docType === 'FOUNDERS_AGREEMENT'
			|| docType === "USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT"
			|| docType === "USA_STRATEGIC_ADVISORY_BOARD_LETTER"
			|| docType === "USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE") {
			return stakeholderList.filter(st => !st.isAnEntity);
		}
		return stakeholderList;
	};

	loadDocumentList(props) {
		const parentOfDocType = {
			GRANT_AGREEMENT: "SHARE_INCENTIVE_PLAN",
			USA_BOARD_APPROVING_OPTION_GRANT: 'USA_EQUITY_INCENTIVE_PLAN',
			USA_OPTION_GRANT_NOTICE: "USA_BOARD_APPROVING_OPTION_GRANT"
		}
		const queryParams = { startupId: props.session.startup.id };
		const documentList = `{ 
        documentList(startupId: "{{startupId}}") {
        name
        status
        kind
        params
        type {
            code
            label
            allowedActions
        }
        id
		}
    }`;
		// TODO add a second parameter documentType to filter on the service

		const query = Mustache.render(documentList, queryParams);
		ServerConnect.graphQlQuery(query).then(result => {
			if (result.documentList) {
				const documents = _.filter(result.documentList, doc => _.get(doc, 'type.code', '') === parentOfDocType[this.props.params.docType] && doc.kind === 'GENERATED');
				this.setState({
					documentList: documents,
				})
			}
		})
	}

	loadGroupCompanies = (props) => {
		this.setState({
			loadingGroupCompanies: true
		})
		const queryParams = { startupId: props.session.startup.id };

		ServerConnect.graphQlQuery(getGroupCompaniesWrong, queryParams, {}, { fetchPolicy: 'network-only', nextFetchPolicy: "network-only" }).then(result => {

			if (result && result.getGroupCompanies) {

				let formalCompanies = _.filter(result.getGroupCompanies, fc => {
					return fc.kind !== 'FORMATION'
				})

				this.setState({
					groupCompanies: _.orderBy(formalCompanies, ['isHoldingCompany'], ['desc']).map(gc => ({
						id: gc.id,
						label: gc.name
					})),
					groupCompaniesList: _.orderBy(formalCompanies, ['isHoldingCompany'], ['desc']),
					authorizedSignatories: _.flatten(
						_.orderBy(formalCompanies, ['isHoldingCompany'], ['desc']).map(gc =>
							gc.authorizedSignatories.map(role => ({
								id: role.stakeholder.id,
								label: role.stakeholder.fullName,
								email: role.stakeholder.email,
								groupCompanyId: gc.id,
							})),
						)
					),
					loadingGroupCompanies: false
				});
			}
		});
	};

	componentDidMount() {

		this.loadStakeholders(this.props);
		this.loadGroupCompanies(this.props, true);

		this.setToolTipsByDocumentType(this.props.params.docType);
		this.setValidationSchemaInMount(this.props.params.docType);

		if (this.props.params.docType === 'GRANT_AGREEMENT' || this.props.params.docType === 'USA_BOARD_APPROVING_OPTION_GRANT' || this.props.params.docType === 'USA_OPTION_GRANT_NOTICE') {
			this.loadDocumentList(this.props)
		}
	}

	getToolTipsFromContentFul = (tooltipId) => {
		ServerConnect.requestApi(
			`/contentful/tooltips/${tooltipId}`,
			{ method: "GET", headers: { "Content-Type": "application/json" } }
		)
			.then(res => {
				this.setState({
					tooltips: res.response
				});
			})
			.catch(err => {
				console.log("Tooltips from contentful error: ", err);
			});

	};

	updateAuthorizedSignatories = (authorizedSignatories) => {
		const newAS = [...this.state.authorizedSignatories];

		authorizedSignatories.forEach(as => {
			const index = newAS.findIndex(e => e.id === as.id);
			if (index > -1) {
				newAS[index].email = as.email;
			}
		});
		this.setState({ authorizedSignatories: newAS });

	};

	mapAuthorized(stakeholders) {
		const authorized = [];

		stakeholders.forEach(st => {
			const stakeholderName = st.fullName;
			st.roles.map(rol => {
				if (rol.name === "AUTHORIZEDSIGNATORY") {
					authorized.push({
						id: rol.id,
						label: stakeholderName,
						email: st.email
					});
				}
			});
		});

		return authorized;
	}

	mapStakeholders(stakeholderList) {
		//  const stakeholders = [];

		/*         revisar
		stakeholderList.forEach(st => {
			const stakeholderName = st.fullName;

			st.roles.forEach(rol => {

				const stakeholder = {
					id: rol.id,
					label: stakeholderName + ' - ' + rol.name
				};

				stakeholders.push(stakeholder);
			})
		});
*/

		return stakeholderList.map(
			st => {
				return { id: st.id, label: st.fullName };
			}
		);

		// return stakeholders;
	}

	getInitialValues() {
		let initialValues = {};

		if (this.state.forceNextStep && this.state.forceNextStep.values) {
			if (this.state.forceNextStep.values.values) {
				initialValues = this.state.forceNextStep.values.values;
			} else {
				initialValues = this.state.forceNextStep.values;
			}
		}
		initialValues = stripTypenames(initialValues);
		return initialValues;
	}

	setValidationSchema = (documentType) => {
		this.setState({
			preValidationSchema: this.state.validationSchema,
			typeSelected: documentType,
			validationSchema: this.props.formType === "uploadToEdit" ? this.getValidationSchema(documentType).concat(validationsUploadToEdit) : this.getValidationSchema(documentType),
		})
	};

	setValidationSchemaInMount = (documentType) => {
		this.setState({
			preValidationSchema: this.state.validationSchema,
			typeSelected: documentType,
			validationSchema: this.props.formType === "uploadToEdit" ? {} : this.getValidationSchema(documentType),
		})
	};

	getValidationSchema = (documentType) => {
		switch (documentType) {
			case "FOUNDERS_TERM_SHEET":
				return validationsFounderTerms;
			case "USA_STRATEGIC_ADVISORY_BOARD_LETTER":
				return validationsAdvisoryBoardOfLetter
			case "USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT":
				return validationsEmployeeInformationInventionsAgreement
			case "USA_CONSULTANT_INFORMATION_AND_INVENTIONS_AGREEMENT":
				return validationsConsultantInformationInventionsAgreement
			case "USA_BOARD_APPROVING_OPTION_GRANT":
				return validationsBoardApprovingOptionsGrant
			case "IP_ASSIGNMENT":
				return validationsIPAssignment;
			case "SAFE":
				return validationsSAFEAgreement;
			case "CONVERTIBLE_NOTE":
				return validationsCLNAgreement;
			case "ADVISOR_AGREEMENT":
				return validationsAdvisorAgreement;
			case "CONSULTANT_AGREEMENT":
				return validationsConsultantAgreement;
			case "FOUNDERS_AGREEMENT":
				// return this.props.formType === 'uploadToEdit' ? validationsFoundersAgreement3 : validationsFoundersAgreement;
				return this.props.formType === 'uploadToEdit' ? validationsFoundersAgreement3  : validationsFoundersAgreement;
			case "EMPLOYMENT_AGREEMENT_ADGM":
			case "EMPLOYMENT_AGREEMENT_DIFC":
				return validationsEmploymentAgreement
			case "EMPLOYMENT_AGREEMENT_UK":
				return validationsEmploymentAgreementUK;
			case "GRANT_AGREEMENT":
				return validationsGrantAgreement;
			case "USA_OPTION_GRANT_NOTICE":
				return validationsOptionGrantNotice
			case "BOARD_RESOLUTION":
			case "SHARE_INCENTIVE_PLAN_FAQ":
			case "SHARE_INCENTIVE_PLAN":
				return validationSharesIncentivePlan;
			case "FOUNDER_SERVICES_AGREEMENT":
				return validationsFounderServicesAgreement;
			case "RESTRICTIVE_COVENANT_AGREEMENT":
				return validationsRestrictiveCovenantAgreement;
			case "KISS":
				return validationsKISSAgreement;
			case "NDA_MUTUAL":
				return validationsNDAMutual;
			case "WEBSITE_TERMS_OF_USE":
				return validationsWebsiteTermsOfUse;
			case "WEBSITE_PRIVACY_POLICY":
				return validationsWebsitePrivacyPolicy;
			case "WEBSITE_ACCEPTABLE_USE_POLICY":
				return validationsWebsiteAcceptableUsePolicy;
			case "WEBSITE_COOKIE_NOTICE":
				return validationsWebsiteCookieNotice;
			case "BOARD_RESOLUTION_CONVERTIBLE_LOAN_NOTE":
			case "BOARD_RESOLUTION_CONVERTIBLE_SAFE":
			case "BOARD_RESOLUTION_CONVERTIBLE_KISS":
			case "BOARD_RESOLUTION_CONVERTIBLE_FIXED_EQUITY":
			case "BOARD_RESOLUTION_CONVERTIBLE_OTHER":
			case "BOARD_RESOLUTION_CONVERTIBLE":
				return validationsBRCAgreement;
			case "USA_BOARD_CONSENT_SAFE_CONVERTIBLE_LOAN_NOTE":
			case "USA_BOARD_CONSENT_SAFE_SAFE":
			case "USA_BOARD_CONSENT_SAFE_KISS":
			case "USA_BOARD_CONSENT_SAFE_FIXED_EQUITY":
			case "USA_BOARD_CONSENT_SAFE_OTHER":
			case "USA_BOARD_CONSENT_SAFE":
				return validationsBoardResolutionConsentSAFE;
			case "USA_EQUITY_INCENTIVE_PLAN":
			case "USA_STAKEHOLDERS_DIRECTORS_EQUITY_INCENTIVE_PLAN":
				return validationsEquityIncentivePlan;
			case "USA_NDA":
				return validationsUsaNDA;
			//CP-5321
			case "USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE":
				return validationsUsaCalOfferLetterSalaryEmployee;
			case "USA_CONSULTING_AGREEMENT":
				return validationsConsultingAgreement;
			default:
				return validationsDefault
		}
	};

	getLeftEducationId = (documentType) => {
		switch (documentType) {
			case "USA_STRATEGIC_ADVISORY_BOARD_LETTER":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_STRATEGIC_ADVISORY_BOARD_LETTER.LEFT_EDUCATION_ID
			case "USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT.LEFT_EDUCATION_ID;
			case "USA_CONSULTANT_INFORMATION_AND_INVENTIONS_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_CONSULTANT_INFORMATION_AND_INVENTIONS_AGREEMENT.LEFT_EDUCATION_ID;
			case "FOUNDERS_TERM_SHEET":
				return '';
			case "IP_ASSIGNMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.IP_ASSIGNMENT.LEFT_EDUCATION_ID;
			case "SAFE":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.SAFE.LEFT_EDUCATION_ID;
			case "CONVERTIBLE_NOTE":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.CONVERTIBLE_NOTE.LEFT_EDUCATION_ID;
			case "ADVISOR_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.ADVISOR_AGREEMENT.LEFT_EDUCATION_ID;
			case "CONSULTANT_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.CONSULTANT_AGREEMENT.LEFT_EDUCATION_ID;
			case "EMPLOYMENT_AGREEMENT_ADGM":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.EMPLOYMENT_AGREEMENT_ADGM.LEFT_EDUCATION_ID;
			case "EMPLOYMENT_AGREEMENT_DIFC":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.EMPLOYMENT_AGREEMENT_DIFC.LEFT_EDUCATION_ID;
			case "EMPLOYMENT_AGREEMENT_UK":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.EMPLOYMENT_AGREEMENT_UK.LEFT_EDUCATION_ID;
			case "GRANT_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.GRANT_AGREEMENT.LEFT_EDUCATION_ID;
			case "USA_OPTION_GRANT_NOTICE":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_OPTION_GRANT_NOTICE.LEFT_EDUCATION_ID;
			case "USA_BOARD_APPROVING_OPTION_GRANT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_BOARD_APPROVING_OPTION_GRANT.LEFT_EDUCATION_ID;
			case "BOARD_RESOLUTION":
			case "SHARE_INCENTIVE_PLAN_FAQ":
			case "SHARE_INCENTIVE_PLAN":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.SHARE_INCENTIVE_PLAN.LEFT_EDUCATION_ID;
			case "FOUNDER_SERVICES_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.FOUNDER_SERVICES_AGREEMENT.LEFT_EDUCATION_ID;
			case "FOUNDERS_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.FOUNDERS_AGREEMENT.LEFT_EDUCATION_ID;
			case "RESTRICTIVE_COVENANT_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.RESTRICTIVE_COVENANT_AGREEMENT.LEFT_EDUCATION_ID;
			case "NDA_MUTUAL":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.NDA_MUTUAL.LEFT_EDUCATION_ID;
			case "WEBSITE_COOKIE_NOTICE":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.WEBSITE_COOKIE_NOTICE.LEFT_EDUCATION_ID;
			case "WEBSITE_TERMS_OF_USE":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.WEBSITE_TERMS_OF_USE.LEFT_EDUCATION_ID;
			case "WEBSITE_PRIVACY_POLICY":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.WEBSITE_PRIVACY_POLICY.LEFT_EDUCATION_ID;
			case "WEBSITE_ACCEPTABLE_USE_POLICY":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.WEBSITE_ACCEPTABLE_USE_POLICY.LEFT_EDUCATION_ID;
			case "KISS":
				return '';
			case "BOARD_RESOLUTION_CONVERTIBLE_LOAN_NOTE":
			case "BOARD_RESOLUTION_CONVERTIBLE_SAFE":
			case "BOARD_RESOLUTION_CONVERTIBLE_KISS":
			case "BOARD_RESOLUTION_CONVERTIBLE_FIXED_EQUITY":
			case "BOARD_RESOLUTION_CONVERTIBLE_OTHER":
			case "BOARD_RESOLUTION_CONVERTIBLE":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.BOARD_RESOLUTION_CONVERTIBLE.LEFT_EDUCATION_ID;
			case "USA_BOARD_CONSENT_SAFE_CONVERTIBLE_LOAN_NOTE":
			case "USA_BOARD_CONSENT_SAFE_SAFE":
			case "USA_BOARD_CONSENT_SAFE_KISS":
			case "USA_BOARD_CONSENT_SAFE_FIXED_EQUITY":
			case "USA_BOARD_CONSENT_SAFE_OTHER":
			case "USA_BOARD_CONSENT_SAFE":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_BOARD_CONSENT_SAFE.LEFT_EDUCATION_ID;
			case "USA_STAKEHOLDERS_DIRECTORS_EQUITY_INCENTIVE_PLAN":
			case "USA_EQUITY_INCENTIVE_PLAN":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_EQUITY_INCENTIVE_PLAN.LEFT_EDUCATION_ID;
			case "USA_NDA":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_NDA.LEFT_EDUCATION_ID;
			//CP-5321
			case "USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE.LEFT_EDUCATION_ID;
			case "USA_CONSULTING_AGREEMENT":
				return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_CONSULTING_AGREEMENT.LEFT_EDUCATION_ID;
			// Y-COMBINATOR Documents
			case 'POST_MONEY_VALUATION_CAP':
				return 	Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.POST_MONEY_VALUATION_CAP.LEFT_EDUCATION_ID
				case 'POST_MONEY_VALUATION_CAP_USA':
					return 	Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.POST_MONEY_VALUATION_CAP_USA.LEFT_EDUCATION_ID
			case 'SAFE_DISCOUNT_ONLY_USA':
				return 	Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.SAFE_DISCOUNT_ONLY_USA.LEFT_EDUCATION_ID
				case 'SAFE_MFN_ONLY_USA':
				return 	Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.SAFE_MFN_ONLY_USA.LEFT_EDUCATION_ID
				case 'POST_MONEY_VALUATION_CAP_SINGAPORE':
					return Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.POST_MONEY_VALUATION_CAP_SINGAPORE.LEFT_EDUCATION_ID
			default:
				return
		}
	};

	setToolTipsByDocumentType = (documentType) => {
		switch (documentType) {
			case "FOUNDERS_TERM_SHEET":
				return '';
			case "USA_STRATEGIC_ADVISORY_BOARD_LETTER":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_STRATEGIC_ADVISORY_BOARD_LETTER.TOOLTIP)
			case "USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_CAL_EMPLOYEE_INFORMATION_AND_INVENTIONS_AGREEMENT.TOOLTIP)
			case "USA_CONSULTANT_INFORMATION_AND_INVENTIONS_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_CONSULTANT_INFORMATION_AND_INVENTIONS_AGREEMENT.TOOLTIP)
			case "IP_ASSIGNMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.IP_ASSIGNMENT.TOOLTIP);
			case "SAFE":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.SAFE.TOOLTIP);
			case "CONVERTIBLE_NOTE":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.CONVERTIBLE_NOTE.TOOLTIP);
			case "EMPLOYMENT_AGREEMENT_ADGM":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.EMPLOYMENT_AGREEMENT_ADGM.TOOLTIP);
			case "EMPLOYMENT_AGREEMENT_DIFC":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.EMPLOYMENT_AGREEMENT_DIFC.TOOLTIP);
			case "EMPLOYMENT_AGREEMENT_UK":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.EMPLOYMENT_AGREEMENT_UK.TOOLTIP);
			case "GRANT_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.GRANT_AGREEMENT.TOOLTIP);
			case "USA_OPTION_GRANT_NOTICE":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_OPTION_GRANT_NOTICE.TOOLTIP);
			case "USA_BOARD_APPROVING_OPTION_GRANT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_BOARD_APPROVING_OPTION_GRANT.TOOLTIP);
			case "FOUNDER_SERVICES_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.FOUNDER_SERVICES_AGREEMENT.TOOLTIP);
			case "FOUNDERS_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.FOUNDERS_AGREEMENT.TOOLTIP);
			case "SHARE_INCENTIVE_PLAN":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.SHARE_INCENTIVE_PLAN.TOOLTIP);
			case "ADVISOR_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.ADVISOR_AGREEMENT.TOOLTIP);
			case "CONSULTANT_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.CONSULTANT_AGREEMENT.TOOLTIP);
			case "RESTRICTIVE_COVENANT_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.RESTRICTIVE_COVENANT_AGREEMENT.TOOLTIP);
			case "NDA_MUTUAL":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.NDA_MUTUAL.TOOLTIP);
			case "WEBSITE_TERMS_OF_USE":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.WEBSITE_TERMS_OF_USE.TOOLTIP);
			case "WEBSITE_PRIVACY_POLICY":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.WEBSITE_PRIVACY_POLICY.TOOLTIP);
			case "WEBSITE_COOKIE_NOTICE":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.WEBSITE_COOKIE_NOTICE.TOOLTIP);
			case "WEBSITE_ACCEPTABLE_USE_POLICY":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.WEBSITE_ACCEPTABLE_USE_POLICY.TOOLTIP)
			case "KISS":
				return '';
			case "BOARD_RESOLUTION_CONVERTIBLE_LOAN_NOTE":
			case "BOARD_RESOLUTION_CONVERTIBLE_SAFE":
			case "BOARD_RESOLUTION_CONVERTIBLE_KISS":
			case "BOARD_RESOLUTION_CONVERTIBLE_FIXED_EQUITY":
			case "BOARD_RESOLUTION_CONVERTIBLE_OTHER":
			case "BOARD_RESOLUTION_CONVERTIBLE":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.BOARD_RESOLUTION_CONVERTIBLE.TOOLTIP);
			case "USA_BOARD_CONSENT_SAFE_CONVERTIBLE_LOAN_NOTE":
			case "USA_BOARD_CONSENT_SAFE_SAFE":
			case "USA_BOARD_CONSENT_SAFE_KISS":
			case "USA_BOARD_CONSENT_SAFE_FIXED_EQUITY":
			case "USA_BOARD_CONSENT_SAFE_OTHER":
			case "USA_BOARD_CONSENT_SAFE":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_BOARD_CONSENT_SAFE.TOOLTIP);
			case "USA_EQUITY_INCENTIVE_PLAN":
			case "USA_STAKEHOLDERS_DIRECTORS_EQUITY_INCENTIVE_PLAN":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_EQUITY_INCENTIVE_PLAN.TOOLTIP);
			case "USA_NDA":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_NDA.TOOLTIP);
			//CP-5321
			case "USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_CAL_OFFER_LETTER_SALARY_EMPLOYEE.TOOLTIP);
			case "USA_CONSULTING_AGREEMENT":
				return this.getToolTipsFromContentFul(Constants.CONTENTFUL.ENTRIES.FORMS.AGREEMENT.GENERATE.USA_CONSULTING_AGREEMENT.TOOLTIP);
			default:
				return
		}
	};

	setPreviousStepBasedOnFormType = (formType) => {
		let vecWP = [];
		if (formType === "uploadToEdit") {
			if (this?.props?.params?.templateId) {
				vecWP.push(
					<MicroFrontend id="MF_GenerateDocument_" component={"./ModeCustomFile"} mf="documents" params={{
						docType : this.props.params.docType,
						templateId : this.props.params.templateId,
						startupId : this.props.session.startup.id,
						customTemplateId : this.props.params.customTemplateId,
						documentDraftId : this.props.params.id,
						onCancel: () => {
							//back to document
						  this.props.goToPage(Constants.PAGES.documents);
						},
						goToDocuments: () => {
							this.props.goToPage(Constants.PAGES.documents);
						}
					  }} />

				)
			} else {
					vecWP.push(
						<StepToUploadEditedDoc
							tooltips={this.state.tooltips}
						/>)
			}

		}
		vecWP.push(
			<FormsSelector
				docType={this.props.params.docType}
				formType={this.props.formType}
				isEdit={this.props.isEdit}
				generateDocument={this.props.formType === 'uploadToEdit' ? this.uploadToEditFirstButton : this.generateAgreement}
				setShowButtons={this.setShowButtons}
				startup={this.props.session.startup}
				documentsTypes={this.state.documentsTypes}
				loadStakeholders={() => this.loadStakeholders(this.props)}
				loadGroupCompanies={() => this.loadGroupCompanies(this.props)}
				documentTypesList={this.state.documentTypesList}
				initialValues={this.getInitialValues()}
				extraValues={this.state.extraValues}
				stakeholders={this.state.stakeholders}
				stakeholderList={_.map(this.state.stakeholderList, st => ({ ...st }))}
				groupCompanies={this.state.groupCompanies}
				groupCompaniesList={this.state.groupCompaniesList}
				documentList={this.state.documentList}
				authorizedSignatories={this.state.authorizedSignatories}
				setValidationSchema={this.setValidationSchema}
				values={
					this.state.forceNextStep
						? this.state.forceNextStep.values
						: undefined
				}
				refresh={() =>
					this.setState(prevState => ({
						counter: (prevState.counter += 1)
					}))
				}
				c={this.state.counter}
				tooltips={this.state.tooltips}
			/>
		);
		vecWP.push(<Step2 tooltips={this.state.tooltips} label={this.state.typeSelected} />);
		vecWP.push(<Step3
			generatedAgreement={this.state.generatedAgreement}
			file={this.state.file}
			generatedAgreements={this.state.generatedAgreements}
			tooltips={this.state.tooltips}
			footer={this.state.footerStep3}
		/>);
		vecWP.push(
			<Step4 tooltips={this.state.tooltips} />
		);
		vecWP.push(
			<React.Fragment>
				{this.state.typeSelected && this.getStep5ByDocumentType(this.state.typeSelected)}
			</React.Fragment>
		);
		vecWP.push(
			<Step4 tooltips={this.state.tooltips} />
		);
		return vecWP
	};

	goToPrevStep = () => {
		this.setState((state) => ({
			validationSchema: state.preValidationSchema,
			preValidationSchema: null
		}))
	}

	render() {
		const initialValues = this.getInitialValues();
		return (
			<Loading show={this.state.showLoading} showChildren={false}>
				<div>
					<Wizard
						isEdit={this.props.params.id}
						formType={this.props.formType}
						showDisclaimer={true}
						extraButton={this.state.extraButton}
						hideClose={this.state.nextButton.onClick === this.requestSignatures}
						formTitle={"Generate Document"}
						formSubTitle={
							"Lorem ipsum dolor description that goes within every step"
						}
						leftEducationId={this.getLeftEducationId(this.props.params.docType)}
						initialValues={initialValues}
						onSubmit={(values, actions) => {
							this.submitForm(values, actions);
						}}
						handleClose={this.handleClose}
						validationSchema={this.state.validationSchema}
						nextButton={this.state.nextButton}
						backButton={this.state.backButton}
						showButtons={this.state.showButtons}
						footer={this.state.footer}
						showSteps={this.state.showSteps}
						forceNextStep={this.state.forceNextStep}
						fullScreenModal={this.state.fullScreenModal}
						goToPrevStep={this.goToPrevStep}
					>
						{this.setPreviousStepBasedOnFormType(this.props.formType).map((element, i) => {
							return (
								<Wizard.Page key={i}>
									{element}
								</Wizard.Page>
							)
						})}

					</Wizard>
				</div>
			</Loading>
		);
	}
}

const mapStateToProps = state => ({
	session: state.session,
	store: state
});
const mapDispatchToProps = dispatch => ({
	goToPage: (page, params) => {
		goToPage(dispatch, page, params)
	},
	goToPrevPage: (reload, defaultPage, params) => {
		goToPrevPage(dispatch, reload, defaultPage, params)
	},
	refreshProfile: (value) => {
		/* TODO newField is a patch to revolve 5328 Have to talk about how to revolve the issue  */

		const startup = {
			newField: true,
		}

		dispatch({ type: "SESSION_UPDATE_STARTUP", startup })

	}


});


const GenerateDocumentFormOldConnect = connect(
	mapStateToProps,
	mapDispatchToProps
)(GenerateDocumentFormOld);

export default function GenerateDocumentForm(props) {
	const parmas = useParams();
	return <GenerateDocumentFormOldConnect {...props} params={parmas} />
}
